import RefinementErrorAlert from '../../components/scribe/RefinementErrorAlert';
import { isDocumentShared } from './useDocumentSharing';
import ClientWorkspaceRoute from './ClientWorkspaceRoute';
import ClientConsentLog from './ClientConsentLog';
import ClientPackages from '../Appointments/ClientPackages/ClientPackages';
import { resolveSophieReport, sophieReportLabel } from '../../utils/sophieReportContext';
import ScribeThemeProvider from '../../components/scribe/ScribeThemeProvider';
import { ScribePanel, ScribeText } from '../../components/scribe/ScribeUI';
import { scribeTokens as ui } from '../../components/scribe/tokens';
import { hasUnavailableReportSources, reportSourceIds, resolveReportSources } from '../../utils/reportSources';
import { isDigitalDocumentSource } from '../../utils/digitalDocumentSource';
import useReportSourcePreparation from './useReportSourcePreparation';
import ReportSourcePreparationPanel from './ReportSourcePreparationPanel';
import ConsultationTranscriptPanel from './ConsultationTranscriptPanel';
import { RefinePendingDialog, RefineRegenerateDialog, RefineNavigationDialog } from './RefinePendingDialogs';
import ConsultationTitleBar from './ConsultationTitleBar';
import ConsultationReportDialog from './ConsultationReportDialog';
import { isHomePracticeTitle, templateDisplayTitle } from './homeworkPracticeTemplate';
import { consultationSessionDate } from './consultationSessionDate';
import ConsultationReportHeader, { useReportTools } from './ConsultationReportHeader';
import ConsultationLivePanel from './ConsultationLivePanel';
import { CREDIT_COSTS } from '../../constants/subscriptionPlans';
import ConsultationWritePanel from './ConsultationWritePanel';
import ConsultationRecordingPanel from './ConsultationRecordingPanel';
import RecordedTranscriptionRecovery from './RecordedTranscriptionRecovery';
import RecordingProgress, { transcriptionStageLabel } from './RecordingProgress';
import ConsultationFilesPanel from './ConsultationFilesPanel';
import PatientWorkspaceNavigation from './PatientWorkspaceNavigation';
import ConsultationWorkflowPicker from './ConsultationWorkflowPicker';
import PatientProfilePanel from './PatientProfilePanel';
import PatientSummaryHeader from './PatientSummaryHeader';
import { useRecordingNavigationGuard } from '../../context/RecordingNavigationGuard';
import { TRUNCATION_NOTICE } from '../../constants/askSophieStreaming.js';
import { hasVisibleSources } from '../../utils/askSophieStream.js';
import { authedFetch } from '../../utils/backendFetch.js';
import SophieSources from '../../components/SophieSources';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Alert, Container, Button, Typography, Box, IconButton, MenuItem, Stack, TextField, FormControlLabel, Switch, Select as MuiSelect, Chip, Badge, Checkbox, InputAdornment, CircularProgress, GlobalStyles, Divider, Portal } from '@mui/material';
import { TableBody as MuiTableBody, TableCell as MuiTableCell, TableHead as MuiTableHead, TableRow as MuiTableRow, Table as MuiTable, Tabs, Tab, Avatar, Paper, FormControl, InputLabel, Skeleton } from '@mui/material';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions 
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Link, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';
import ListIcon from '@mui/icons-material/List';
import CopyIcon from '@mui/icons-material/FileCopy';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckIcon from '@mui/icons-material/Check';
import UndoIcon from '@mui/icons-material/Undo';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import LanguageIcon from '@mui/icons-material/Language';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import PopupMenu from '../PopupMenu/PopupMenu.js';
import Loader from '../../loader.js';
import MiniDrawer from '../../components/MiniDrawer.js';
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import Select from 'react-select';
import AlertDialog from '../../Dialog.js';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MedicalCoding from './MedicalCoding/MedicalCoding.js';
import { CW_UNMETERED_PROVIDERS_ENABLED } from '../../constants/cwUnmeteredProviders.js'; // CW-006 kill-switch (add-speaker-labels-stream / medical-icd-codes)
import { useMedicalScribeSummaryData } from './MedicalScribeTranscriptionData.js';
import { getConnectionStatus } from '../../utils/scribeConnection.js';
import useLinkedClientContact from '../../utils/useLinkedClientContact';
// Split component removed - using CSS flex layout instead
// import Split from 'react-split';
// import '../../SplitStyles.css';
import '../../ChatResizable.css'
import { Resizable } from 'react-resizable';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DescriptionIcon from '@mui/icons-material/Description';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Menu from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { supabase } from '../../supabaseClient.js';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import InsightsIcon from '@mui/icons-material/Insights';
import TemplateView from '../Settings/Template/TemplateView.js';
import { set } from 'date-fns';
import ReportSummaryView from './ReportSummaryView.js';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import MicIcon from '@mui/icons-material/Mic';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PDFFormUploader from '../../components/PDFFormUploader.js';
import { Edit } from '@mui/icons-material';
import { PRE_EXISTING_CONDITIONS } from '../../constants/preExistingConditions.js';
import SophieWorkspaceLayout from './SophieWorkspaceLayout';
import SophieAssistantPanel from './SophieAssistantPanel';
import SearchableMultiSelect from '../../components/SearchableMultiSelect.js';
import { DSM5_CONDITIONS } from '../../constants/dsm5Conditions.js';
import { countryCodes } from '../../constants/countryCodes.js';
import SearchableSingleSelect from '../../components/SearchableSingleSelect.js';
import PatientDocuments from './Views/PatientDocuments.js';
import LinkedPatientProfile from './Views/LinkedPatientProfile.js';
import DocumentPreviewModal from './DocumentPreviewModal.js';
import AttachmentOcrDialog from './AttachmentOcrDialog';
import WriteReportDocument from './WriteReportDocument';
import { createTypedDocumentDraft, insertTypedDocument } from '../../utils/typedDocument';
import WriteReportActions from './WriteReportActions';
import { WriteSourcePanel } from './WriteSourceText';
import { canReviewOcr } from '../../utils/attachmentOcr';
import { ATTACHMENT_OCR_ENABLED } from '../../utils/attachmentOcr';
import { useEditor, EditorContent } from '@tiptap/react';
import { Extension } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextStyle from '@tiptap/extension-text-style';
import {
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  TextDecrease,
  TextIncrease,
  FormatListBulleted,
  FormatListNumbered,
} from "@mui/icons-material";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import HighlightIcon from '@mui/icons-material/Highlight';
import VitalsDashboard from './Dashboard/VitalsDashboard.js';
import { applySavedPatient } from '../../utils/patientNavigationState.js';

const FontSize = Extension.create({
  name: 'fontSize',
  addOptions() {
    return { types: ['textStyle'] };
  },
  addGlobalAttributes() {
    return [{
      types: this.options.types,
      attributes: {
        fontSize: {
          default: null,
          parseHTML: element => element.style.fontSize || null,
          renderHTML: attributes => {
            if (!attributes.fontSize) return {};
            return { style: `font-size: ${attributes.fontSize}` };
          },
        },
      },
    }];
  },
  addCommands() {
    return {
      setFontSize: fontSize => ({ chain }) =>
        chain().setMark('textStyle', { fontSize }).run(),
      unsetFontSize: () => ({ chain }) =>
        chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run(),
    };
  },
});

const DEFAULT_PHONE_CODE = '852';

const DownloadIndicator = ({ isDownloading }) => {
  if (!isDownloading) return null;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#29C0BB',
        color: 'white',
        padding: '12px 20px',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}
    >
      <CircularProgress size={20} sx={{ color: 'white' }} />
      <Typography variant="body2">Downloading file...</Typography>
    </Box>
  );
};

const formatUploadBytes = (bytes) => {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 MB';
  const mb = bytes / (1024 * 1024);
  return mb >= 10 ? `${Math.round(mb)} MB` : `${mb.toFixed(1)} MB`;
};

// `progress` is the aggregate across the whole selection (utils/storageUpload's
// createBatchProgress). It only arrives once encryption finishes and the first bytes
// leave, so the spinner-only form still covers the gap before that — for a large file
// that gap is the single-buffer encrypt, which reports nothing.
const UploadIndicator = ({ isUploading, progress }) => {
  // Progress alone is enough to show it: consultation attachments (handleFileSubmit)
  // never set isUploading, so that path used to upload with no indicator at all.
  if (!isUploading && !progress) return null;
  const percent = progress?.total
    ? Math.min(100, Math.round((progress.loaded / progress.total) * 100))
    : null;
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#29C0BB',
        color: 'white',
        padding: '12px 20px',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        minWidth: percent === null ? 0 : 260,
      }}
    >
      <CircularProgress
        size={20}
        sx={{ color: 'white' }}
        {...(percent === null ? {} : { variant: 'determinate', value: percent })}
      />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2">
          {percent === null
            ? 'Preparing upload…'
            : progress.attempt > 1
              ? `Connection dropped — retrying (${progress.attempt} of ${progress.attempts})…`
              : `Uploading ${progress.files > 1 ? `${progress.files} files` : 'file'} — ${percent}%`}
        </Typography>
        {percent !== null && (
          <Typography variant="caption" sx={{ opacity: 0.85, fontVariantNumeric: 'tabular-nums' }}>
            {formatUploadBytes(progress.loaded)} / {formatUploadBytes(progress.total)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const RefiningTranscriptIndicator = ({ isRefining, hasError, error, onRetry, retryDisabled, isPending }) => {
  if (!isRefining && !hasError && !isPending) return null;

  if (hasError && !isRefining) return <RefinementErrorAlert error={error || {}} onRetry={onRetry} disabled={retryDisabled} />;

  const styles = isRefining
    ? { bg: '#F0FDFA', border: '#29C0BB', color: '#29C0BB' }
    : { bg: '#EFF6FF', border: '#93C5FD', color: '#2563EB' };

  const message = isRefining
    ? 'Refining your transcript, please wait...'
    : 'Refined transcript could not be saved. The result is still here; use Save changes to retry.';

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      backgroundColor: styles.bg,
      border: `1px solid ${styles.border}`,
      padding: '8px 14px',
      borderRadius: '8px',
      mb: 1,
    }}>
      {isRefining && <CircularProgress size={16} sx={{ color: '#29C0BB' }} />}
      <Typography variant="caption" sx={{ fontWeight: 600, color: styles.color }}>
        {message}
      </Typography>
    </Box>
  );
};

const RemarksMenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <Box
      sx={{
        border: '1px solid #ddd',
        p: 1,
        borderRadius: 1,
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5
      }}
    >
      <Tooltip title="Bold">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            editor.chain().focus().toggleBold().run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: editor.isActive('bold') ? 'rgba(41, 192, 187, 0.1)' : 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <FormatBold />
        </IconButton>
      </Tooltip>

      <Tooltip title="Italic">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            editor.chain().focus().toggleItalic().run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: editor.isActive('italic') ? 'rgba(41, 192, 187, 0.1)' : 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <FormatItalic />
        </IconButton>
      </Tooltip>

      <Tooltip title="Underline">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            editor.chain().focus().toggleUnderline().run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: editor.isActive('underline') ? 'rgba(41, 192, 187, 0.1)' : 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <FormatUnderlined />
        </IconButton>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      <Tooltip title="Decrease font size">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            const current = parseFloat(editor.getAttributes('textStyle').fontSize) || 16;
            editor.chain().focus().setFontSize(`${Math.max(8, current - 2)}px`).run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <TextDecrease />
        </IconButton>
      </Tooltip>

      <Tooltip title="Increase font size">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            const current = parseFloat(editor.getAttributes('textStyle').fontSize) || 16;
            editor.chain().focus().setFontSize(`${Math.min(48, current + 2)}px`).run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <TextIncrease />
        </IconButton>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />

      <Tooltip title="Bullet List">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            editor.chain().focus().toggleBulletList().run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: editor.isActive('bulletList') ? 'rgba(41, 192, 187, 0.1)' : 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <FormatListBulleted />
        </IconButton>
      </Tooltip>

      <Tooltip title="Numbered List">
        <IconButton
          onMouseDown={(event) => {
            event.preventDefault();
            editor.chain().focus().toggleOrderedList().run();
          }}
          size="small"
          sx={{
            color: '#29C0BB',
            bgcolor: editor.isActive('orderedList') ? 'rgba(41, 192, 187, 0.1)' : 'transparent',
            ':hover': {
              bgcolor: 'rgba(41, 192, 187, 0.1)',
            },
          }}
        >
          <FormatListNumbered />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const ConsultationSummary = () => {
    const { confirmNavigation } = useRecordingNavigationGuard();
    const { 
      // Basic data
      id,
      userDetails,
      isAdminUser,
      userMode,
      
      // View states
      mainView,
      leftView,
      rightView,
      setRightView,
      setRightOptions,
      handleMainViewChange,
      handleLeftViewChange,
      handleRightViewChange,
      firstView,
      
      // Language
      language,
      setLanguage,
      
      // View options
      mainOptions,
      leftOptions,
      
      // Popup states
      setPopupReport,
      isPopupReport,
      isPopupPdfFill,
      setPopupPdfFill,
      
      // Consultation data
      currentConsultation,
      sectionSummary,
      setSectionSummary,
      
      // Edit states
      editNote,
      setEditNote,
      
      // Content
      transcription,
      remarks,
      selectedReport,
      editReportContent,
      editPatientInsight,
      setTranscription,
      setRemarks,
      setSelectedReport,
      setEditReportContent,
      setEditPatientInsight,
      
      // Loading states
      loading,
      savingConsultation,
      transcriptionStage,
      piiWarming,
      isRefiningTranscript,
      refineTranscriptError,
      refineTranscriptFailure,
      noSpeechDetected,
      hasCompletedTranscription,
      liveRecognitionInterrupted,
      liveSync,
      liveConnectionWarning,
      transcriptRevealToken,
      isPendingRefinement,
      refinedPreview,
      reportDateSelection,
      setReportDateSelection,
      setRefinedPreview,
      applyStreamingSpeakerLabels,
      acceptRefinement,
      discardRefinement,
      pendingRefineGate,
      refinePendingDialog,
      closeRefinePendingDialog,
      refineRegenerateDialog,
      closeRefineRegenerateDialog,
      regenerateAfterRefine,
      handleSaveTranscription,
      handleSaveRemarks,
      consultationLoading,
      codeLoading,
      patientInsightsLoading,
      patientsInsightsData,
      setPatientsInsightsData,
      generatePatientInsights,
      updatePatientInsights,
      popupPatientInsights,
      setPopupPatientInsights,
      
      // Speech recognition
      isRecognizing,
      isSettling,
      isStarting,
      startupStage,
      sttFromMic,
      isTeleHealthActive,
      setIsTeleHealthActive,

      // References
      textFieldRef,
      transcriptionRef,
      remarksRef,
      
      // File management
      files,
      handleFileChange,
      removeFile,
      downloadFile,
      handleFileSubmit,
      onInputClick,
      
      // Audio settings
      inputSource,
      inputSources,
      setInputSource,
      setSelectedMicId,

      
      // Medical coding
      addedCodes,
      suggestedCodes,
      selectedOption,
      setSelectedOption,
      
      // Actions
      handleCopy,
      addNewConsultation,
      insertConsultation,
      resetConsultationUI,
      viewPastConsultation,
      removeConsultation,
      
      
      // Dialog
      openDialog,
      setOpenDialog,
      setAlert,
      
      // Utils
      convertToGMT8Date,
      convertToGMT8Time,
      handleItemLock,
      handleItemShare,
      sharingDialog,

      // Functions for child components
      fetchAddedCodes,
      fetchSuggestedCodes,
      saveSuggestedCodes,
      setAddedCodes,

      //Options
      MEDICAL_OPTIONS,
      languages,
      transcriptionLanguages,

      //Highlighting
      handleTextHighlight,
      renderHighlightedTranscription,
      clearHighlights,
      highlightMode,   
      setHighlightMode,
      highlightedTexts,
      highlightCount,
      transcriptionTextFieldRef,
      selectedText,
      setSelectedText,
      currentHighlightIndex,
      navigateToNextHighlight,
      navigateToPreviousHighlight,
      retrieving,
      reportDocs,

      //Chat
      chatMessages,
      newMessage,
      setNewMessage,
      handleSendMessage,
      isChatOpen,
      setIsChatOpen,
      isChatLogoOpen,
      setIsChatLogoOpen,
      chatBoxRef,

      // History view
      historyFilter,
      setHistoryFilter,
      searchQuery,
      setSearchQuery,
      selectAll,
      toggleSelectAllItems,
      sortConfig,
      requestSort,
      expandedRows,
      toggleRowExpansion,
      historyItems,
      getFilteredHistoryItems,
      toggleItemSelection,
      handlePatientFileUpload,
      isGeneratingReport,
      generateReportFromConsultation,
      generateComprehensiveReport,

      //options
      rightOptions,
      extractParagraphText,

      //templates
      selectedTemplate,
      defaultTemplate,
      setSelectedTemplate,
      setShowTemplateSelector,
      reportTemplateSelected,
      setReportTemplateSelected,
      showTemplateSelector,
      showTemplateEditor,
      requestTemplateSort,
      templateSortConfig,
      templates,
      handleTemplateSelect,
      ensureHomeworkPracticeTemplate,
      onTemplateSaved,
      handleUploadTemplate,
      templateEditor,
      handleBackToTemplateSelector,
      setShowTemplateEditor,
      selectingReportTemplate,
      setSelectingReportTemplate,

      //menu options
      anchorEl,
      handleMenuClose,
      handleMenuOpen,
      handleViewItem,
      handleDeleteItem,
      handleDownloadReport,
      selectedItem,

      //patient edit
      formSubmitted,
      setFormSubmitted,
      updatePatient,
      patient,
      setPatient,
      teamMembersData,
      deletePatient,

      setHistoryItems,
      responseSources,
      setResponseSources,
      openSource,
      setOpenSource,
      regenerateReportConsultation,
      handleTranscribeAudio,
      isSupportedTranscriptionFile,
      isAudioFileFormat,
      audioOption,
      setAudioOption,
      lastRecording,
      setLastRecording,
      uploadProgress,
      retryRecordingUpload,
      shouldSaveAudio,
      shouldTranscribeNow,
      deleteSelectedHistoryItems,
      requestDeleteHistoryItems,
      selectedItems,
      setSelectedItems,
      clearAllSelections,
      editChiefComplaint,
      setEditChiefComplaint,
      changeChiefComplaint,
      latestComplaint,
      timer,
      regenerateHistoryReport,
      saveChatMessageAsReport,
      handleSaveChatMessageAsReport,
      saveReportDialog,
      setSaveReportDialog,
      answerSource,
      setAnswerSource,
      isAnswerSourceOpen,
      setIsAnswerSourceOpen,
      templatesLoading,
      currentOrg,
      isDownloading,
      latestConsultationReport,
      isUploading,
      fileUploadProgress,

      showTranscriptionLanguagePopup,
      setShowTranscriptionLanguagePopup,
      selectedAudioItemForTranscription,
      performAudioTranscription,
      recordedTranscriptionRecovery,
      retryRecordedTranscriptionSave,
      checkRecordedTranscriptionResult,
      transcriptionLanguage,
      setTranscriptionLanguage,
      setSelectedAudioItemForTranscription,
      retrieveAttachmentFile,
      downloadAttachment,
      changeReportTitle,
      saveTextOnly,
      transcriptSaveStatus,
      saveTranscriptBeforeLeaving,
      saveSelectedConsultationSource,
    } = useMedicalScribeSummaryData();
    
    const fileInputRef = useRef(null);
    const remarksInitializedRef = useRef(false);
    const saveTextTimerRef = useRef(null);

    const theme = useTheme();

    const navigate = useNavigate();
    const location = useLocation();

    const [editingConsultationId, setEditingConsultationId] = useState(null);
    const [editedTitle, setEditedTitle] = useState('');
    const [tempTranscriptionLanguage, setTempTranscriptionLanguage] = useState(transcriptionLanguage);
    const [hasOpenedChat, setHasOpenedChat] = useState(false);

    const [workflowMode, setWorkflowMode] = useState(null); // null | 'live-consultation' | 'write-document' | 'transcribe-recording'
    const [showWorkflowSelector, setShowWorkflowSelector] = useState(true);
    const [showControlPanel, setShowControlPanel] = useState(true);
    const [showPastDocs, setShowPastDocs] = useState(true);
    const [showSidebar, setShowSidebar] = useState(true);
    const [showReportDialog, setShowReportDialog] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [ocrItem, setOcrItem] = useState(null);
    const [ocrQueue, setOcrQueue] = useState([]);
    const [ocrAutoRun, setOcrAutoRun] = useState(false);
    const [ocrGenerationReady, setOcrGenerationReady] = useState({ path: null, ready: false });
    const [writeSourceCheckResult, setWriteSourceCheckResult] = useState(null);
    const ocrOpenedInWrite = useRef(false);
    const openGeneralOcr = item => { ocrOpenedInWrite.current = false; setOcrItem(item); };
    const [ocrRefresh, setOcrRefresh] = useState(0);
    useEffect(() => {
      // Live sessions prioritize transcription; the file library remains
      // available from its clearly labeled workflow control.
      setShowSidebar(workflowMode !== 'live-consultation');
    }, [workflowMode]);
    const [pendingTranscriptAction, setPendingTranscriptAction] = useState(null);
    const [transcriptActionBusy, setTranscriptActionBusy] = useState(false);
    const transcriptActionLock = useRef(false);
    const runTranscriptAction = async action => {
      if (transcriptActionLock.current || isRecognizing || isSettling) return;
      if (isRefiningTranscript || isPendingRefinement) { setPendingTranscriptAction(() => action); return; }
      transcriptActionLock.current = true;
      setTranscriptActionBusy(true);
      try { if (await saveTextOnly()) await action(); }
      finally { transcriptActionLock.current = false; setTranscriptActionBusy(false); }
    };
    const openCurrentTranscriptInWrite = () => {
      setSelectedItems([currentConsultation.id]);
      setWriteDocument(null); setActiveWriteDocumentId(null);
      setWriteFilesSection('sources'); setOcrItem(null);
      setWorkflowMode('write-document'); setShowControlPanel(true);
    };
    const writeSourcesEnabled = ATTACHMENT_OCR_ENABLED && workflowMode === 'write-document';
    const [writeFilesSection, setWriteFilesSection] = useState('sources');
    const [writeDocument, setWriteDocument] = useState(null);
    const [activeWriteDocumentId, setActiveWriteDocumentId] = useState(null);
    const sophieReport = resolveSophieReport({ writeSourcesEnabled, writeDocument, patientId: id,
      historyItems, isPopupReport, selectedReport, sectionSummary, latestConsultationReport });
    const hasSelectedTranscript = historyItems.some(item => selectedItems.includes(item.id) && item.type === 'Consultation');
    const sophieContextLabel = sophieReportLabel(sophieReport, hasSelectedTranscript);
    const sendSophieMessage = () => {
      if (writeSourcesEnabled) {
        if (!checkSavedSources()) return;
        return handleSendMessage({ reportContext: sophieReport,
          onReportUpdated: (reportId, content) => setWriteDocument(current =>
            current?.scopePatientId === id && current.id === reportId
              ? { ...current, originalData: { ...current.originalData, content } } : current),
        });
      }
      return handleSendMessage();
    };
    const activeWriteDocumentRef = useRef(activeWriteDocumentId);
    activeWriteDocumentRef.current = activeWriteDocumentId;
    const [mobilePane, setMobilePane] = useState('source');
    const [sophieWorkspacePane, setSophieWorkspacePane] = useState('report');
    useEffect(() => { setShowReportDialog(false); setMobilePane('source'); }, [workflowMode]);
    useEffect(() => {
      if (writeDocument?.id || sectionSummary?.id) setMobilePane('report');
    }, [writeDocument?.id, sectionSummary?.id]);
    const dirtyWriteSources = useRef(new Set());
    const invalidatePreparation = useRef(null);
    const onSourceDirtyChange = (itemId, dirty) => {
      if (dirty) dirtyWriteSources.current.add(itemId); else dirtyWriteSources.current.delete(itemId);
      if (dirty) invalidatePreparation.current?.();
    };
    const checkSavedSources = () => {
      if (!dirtyWriteSources.current.size) return true;
      setAlert('Save or discard your text changes, or wait for the report to finish saving, before continuing.', 'info');
      return false;
    };
    const requestWriteDeletion = ids => {
      if (!checkSavedSources()) return;
      return requestDeleteHistoryItems(ids, activeWriteDocumentId, {
        canDelete: checkSavedSources,
        isCurrent: () => activeWriteDocumentRef.current === activeWriteDocumentId,
        onDeleted: items => {
          const removedIds = new Set(items.map(item => item.id));
          setWriteDocument(current => removedIds.has(current?.id) ? null : current);
          setActiveWriteDocumentId(current => removedIds.has(current) ? null : current);
          setWriteSourceCheckResult(null);
        },
      });
    };
    const changeWriteFilesSection = section => {
      if (!checkSavedSources()) return false;
      setWriteFilesSection(section);
      if (section === 'sources') setShowReportDialog(false);
      if (section === 'reports') {
        setOcrItem(null); setOcrQueue([]); setOcrAutoRun(false);
      }
      return true;
    };
    const showWriteDocument = item => {
      if (!checkSavedSources()) return;
      // Re-select the source documents attached to this report so the left
      // Source Text pane shows the text that the report was generated from.
      const sourceIds = resolveReportSources(reportSourceIds(item), historyItems).map(source => source.id);
      setSelectedItems(sourceIds);
      setWriteSourceCheckResult(null);
      setHistoryItems(items => items.map(entry => ({ ...entry, isSelected: sourceIds.includes(entry.id) })));
      setActiveWriteDocumentId(item.id);
      setWriteFilesSection('reports');
      setShowReportDialog(false);
      setWriteDocument({ ...item, scopePatientId: id }); setPopupReport(false);
    };
    const applyWriteSelection = (requestedIds) => {
      if ([...dirtyWriteSources.current].some(id => !requestedIds.includes(id)) && !checkSavedSources()) return;
      const ids = requestedIds.filter(id => historyItems.some(item => item.id === id));
      // Resolve against all history, including reports hidden by the Files search.
      const remainingReport = ids.length === 1 && historyItems.find(item => item.id === ids[0] && item.type === 'Document');
      if (remainingReport) { showWriteDocument(remainingReport); return; }
      setWriteDocument(null);
      setActiveWriteDocumentId(null);
      setShowReportDialog(false);
      setSelectedItems(ids);
      setWriteSourceCheckResult(null);
      setHistoryItems(items => items.map(item => ({ ...item, isSelected: ids.includes(item.id) })));
      const firstOcrSource = historyItems.find(item => ids.includes(item.id) && canReviewOcr(item));
      ocrOpenedInWrite.current = Boolean(firstOcrSource);
      if (ids.length !== 1 || !ocrItem || !ids.includes(ocrItem.id)) {
        setOcrAutoRun(false);
        setOcrItem(ids.length === 1 ? firstOcrSource || null : null);
      }
      handleLeftViewChange('Transcription');
    };
    const openWriteOcr = (item) => {
      ocrOpenedInWrite.current = true;
      setOcrQueue([]); setOcrAutoRun(true); setOcrItem(item);
    };
    const writeScopeRef = useRef('');
    writeScopeRef.current = `${id}:${workflowMode}`;
    const uploadWriteFiles = async (event) => {
      if (!checkSavedSources()) return;
      if (workflowMode === 'write-document' && Array.from(event.target?.files || []).some(file => isSupportedTranscriptionFile(file.name))) {
        setAlert('Upload audio in Transcription, then select its transcript here as a source.', 'info');
        return;
      }
      const scope = writeScopeRef.current;
      const items = await handlePatientFileUpload(event);
      if (workflowMode === 'live-consultation' && scope === writeScopeRef.current && items?.length) {
        const audio = items.find(item => isSupportedTranscriptionFile(item.title));
        if (audio) setRecordingSelectedItem(audio);
      }
      if (!writeSourcesEnabled || scope !== writeScopeRef.current || !items?.length || !checkSavedSources()) return;
      const ids = items.map(item => item.id);
      setWriteDocument(null);
      setActiveWriteDocumentId(null);
      setSelectedItems(ids);
      setWriteSourceCheckResult(null);
      setHistoryItems(history => history.map(item => ({ ...item, isSelected: ids.includes(item.id) })));
      handleLeftViewChange('Transcription');
      const supported = items.filter(canReviewOcr);
      if (supported.length) {
        setShowWorkflowSelector(false);
        ocrOpenedInWrite.current = true;
        setOcrQueue(supported); setOcrAutoRun(false); setOcrItem(supported[0]);
      }
    };
    const selectedWriteSources = resolveReportSources(selectedItems, historyItems, { currentConsultation, patientId: id });
    const sourcePreparation = useReportSourcePreparation(selectedWriteSources, `${id}:${workflowMode}`, retrieveAttachmentFile,
      () => setOcrRefresh(value => value + 1));
    invalidatePreparation.current = sourcePreparation.invalidate;
    const prepareWriteSources = () => {
      if (!checkSavedSources()) return;
      return sourcePreparation.prepare();
    };
    const checkSelectedReportSources = async (query) => {
      const availableSources = selectedWriteSources.filter(item => !hasUnavailableReportSources([item]));
      if (!availableSources.length) { setAlert('No available sources to check.', 'warning'); return null; }
      const result = await handleTextHighlight({ sourceItems: availableSources, query });
      setWriteSourceCheckResult(result?.sources ? result : null);
      return result;
    };
    const [checkingWriteSources, setCheckingWriteSources] = useState(false);
    const generateWriteReport = async ({ templateOverride = null } = {}) => {
      if (!writeSourcesEnabled) return generateComprehensiveReport({ templateOverride });
      if (checkingWriteSources || sourcePreparation.busy || !checkSavedSources()) return;
      if (!selectedWriteSources.length || selectedWriteSources.length !== selectedItems.length) {
        setAlert('Select the files to use before generating a document.', 'info'); return;
      }
      if (hasUnavailableReportSources(selectedWriteSources)) {
        setAlert('Some sources are unavailable. Reload the file list or select available files before generating a document.', 'warning'); return;
      }
      if (selectedWriteSources.some(item => isAudioFileFormat(item.title))) {
        setAlert('Transcribe audio in Recordings first, then select its transcription in Write.', 'info'); return;
      }
      const unsupported = selectedWriteSources.find(item => item.type === 'Attachment' && !canReviewOcr(item) && !isDigitalDocumentSource(item));
      if (unsupported) {
        setAlert(`${unsupported.title} cannot be included in this report. Use DOCX, TXT, CSV, XLSX, PDF or images, or remove it from the selection.`, 'info'); return;
      }
      if (!sourcePreparation.ready) {
        setShowReportDialog(false);
        await prepareWriteSources();
        return; // Preparation never submits or charges for a report.
      }
      setCheckingWriteSources(true);
      try {
        if (!checkSavedSources()) return;
        const generated = await generateComprehensiveReport({ useSelectedSources: true, preparedSources: selectedWriteSources, templateOverride });
        if (generated) {
          setWriteSourceCheckResult(null);
          setOcrItem(null); setOcrQueue([]); setOcrAutoRun(false); setOcrRefresh(value => value + 1);
          setWriteFilesSection('reports');
          setWriteDocument({ ...generated, scopePatientId: id }); setActiveWriteDocumentId(generated.id);
        }
        return generated;
      } catch (error) {
        setAlert(error.message, 'error');
      } finally { setCheckingWriteSources(false); }
    };
    const [isTitleEditing, setIsTitleEditing] = useState(false);
    const [titleEditValue, setTitleEditValue] = useState('');
    const [previewItem, setPreviewItem] = useState(null);
    const [activeDocumentTab, setActiveDocumentTab] = useState('generated'); // 'generated' | 'manual'
    const openWriteFile = item => {
      if (!checkSavedSources()) return;
      // Opening a source also makes it the single source for the next report.
      setWriteFilesSection('sources');
      applyWriteSelection([item.id]);
      if (item.type === 'Consultation' || item.type === 'Document' || isDigitalDocumentSource(item)) { setOcrItem(null); return; }
      if (canReviewOcr(item)) { setShowWorkflowSelector(false); ocrOpenedInWrite.current = true; setOcrQueue([]); setOcrAutoRun(false); setOcrItem(item); }
      else { setOcrItem(null); setPreviewItem(item); setPreviewOpen(true); }
    };
    const [recordingSelectedItem, setRecordingSelectedItem] = useState(null);
    const [isRecordingDragOver, setIsRecordingDragOver] = useState(false);
    const [leftPanelWidth, setLeftPanelWidth] = useState(280);
    const leftPanelWidthRef = useRef(280);
    const isResizingPanelRef = useRef(false);
    const panelDragStartXRef = useRef(0);
    const panelDragStartWidthRef = useRef(280);

    const [sideBySideLeftWidth, setSideBySideLeftWidth] = useState(480);
    const sideBySideLeftWidthRef = useRef(480);
    const isResizingSideBySideRef = useRef(false);
    const sideBySideDragStartXRef = useRef(0);
    const sideBySideDragStartWidthRef = useRef(480);
    const sideBySideContainerRef = useRef(null);
    useEffect(() => {
      if (!transcriptRevealToken || !['live-consultation', 'transcribe-recording'].includes(workflowMode)
        || !hasCompletedTranscription) return undefined;
      setMobilePane('source');
      const frame = requestAnimationFrame(() => {
        sideBySideContainerRef.current?.scrollIntoView({
          behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      });
      return () => cancelAnimationFrame(frame);
    }, [transcriptRevealToken, workflowMode, hasCompletedTranscription]);

    const [highlightBtnPos, setHighlightBtnPos] = useState(null); // { x, y } viewport coords for floating highlight button

    const remarksEditor = useEditor({
      extensions: [
        StarterKit,
        Underline,
        TextStyle,
        FontSize,
      ],
      onUpdate: ({ editor }) => {
        setRemarks(editor.getHTML());
      },
    });

    // Add useEffect to sync remarks content with editor
    useEffect(() => {
      if (!remarksEditor) return;

      const nextHtml = remarks || '';
      const currentHtml = remarksEditor.getHTML();

      if (!remarksInitializedRef.current || nextHtml !== currentHtml) {
        remarksEditor.commands.setContent(nextHtml, false, { preserveWhitespace: true });
        remarksInitializedRef.current = true;
      }
    }, [remarks, remarksEditor]);

    useEffect(() => {
      if (showTranscriptionLanguagePopup) {
        setTempTranscriptionLanguage(transcriptionLanguage);
      }
    }, [showTranscriptionLanguagePopup, transcriptionLanguage]);

    useEffect(() => { if (!isChatOpen) setSophieWorkspacePane('report'); }, [isChatOpen]);

    useEffect(() => {
      if (isChatOpen && !hasOpenedChat) {
        setHasOpenedChat(true);
      }
    }, [isChatOpen, hasOpenedChat]);

    useEffect(() => {
      if (!isChatOpen) return undefined;
      const closeOnEscape = (event) => {
        if (event.key === 'Escape') setIsChatOpen(false);
      };
      document.addEventListener('keydown', closeOnEscape);
      return () => document.removeEventListener('keydown', closeOnEscape);
    }, [isChatOpen, setIsChatOpen]);

    // A streamed answer grows inside a message that is already in the list, so
    // chatMessages.length never changes while it arrives. Following the text
    // needs something that does: the length of the last bubble's text.
    const lastMessageLength = chatMessages[chatMessages.length - 1]?.message?.length || 0;

    // Whether the panel should keep following new text. Updated from the scroll
    // handler rather than measured inside the effect, because by the time the
    // effect runs the DOM has already grown — a doctor sitting at the bottom
    // would measure as "scrolled up" by exactly the height of the new text and
    // the panel would stop following at the worst possible moment.
    const followChatBottomRef = useRef(true);

    const handleChatScroll = useCallback(() => {
      const el = chatBoxRef.current;
      if (!el) return;
      // A doctor who has scrolled up to re-read something must not be yanked
      // back down on every token; ~2 lines of slack absorbs rounding and
      // momentum scrolling.
      followChatBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 48;
    }, [chatBoxRef]);

    useEffect(() => {
      if (!(isChatOpen || isChatLogoOpen)) return;

      const scrollTarget = chatBoxRef.current;
      if (!scrollTarget) return;
      if (!followChatBottomRef.current) return;

      const rafId = requestAnimationFrame(() => {
        scrollTarget.scrollTop = scrollTarget.scrollHeight;
      });

      return () => cancelAnimationFrame(rafId);
    }, [chatMessages.length, lastMessageLength, isChatOpen, isChatLogoOpen, isPopupReport, chatBoxRef]);

    // Opening the panel, or sending a question, always returns to the bottom:
    // that is the doctor asking to see what happens next.
    useEffect(() => {
      followChatBottomRef.current = true;
    }, [chatMessages.length, isChatOpen, isChatLogoOpen, isPopupReport]);



    // Panel resize drag — document-level listeners registered once
    useEffect(() => {
      const onMouseMove = (e) => {
        if (!isResizingPanelRef.current) return;
        const delta = e.clientX - panelDragStartXRef.current;
        const newWidth = Math.min(Math.max(180, panelDragStartWidthRef.current + delta), 540);
        setLeftPanelWidth(newWidth);
        leftPanelWidthRef.current = newWidth;
      };
      const onMouseUp = () => { isResizingPanelRef.current = false; };
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      return () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };
    }, []);

    const handlePanelDragStart = (e) => {
      isResizingPanelRef.current = true;
      panelDragStartXRef.current = e.clientX;
      panelDragStartWidthRef.current = leftPanelWidthRef.current;
      e.preventDefault();
    };

    // Side-by-side column resize — same pattern as panel resize
    useEffect(() => {
      const onMouseMove = (e) => {
        if (!isResizingSideBySideRef.current) return;
        const delta = e.clientX - sideBySideDragStartXRef.current;
        const containerWidth = sideBySideContainerRef.current?.offsetWidth || 960;
        const newWidth = Math.min(
          Math.max(200, sideBySideDragStartWidthRef.current + delta),
          containerWidth - 200
        );
        setSideBySideLeftWidth(newWidth);
        sideBySideLeftWidthRef.current = newWidth;
      };
      const onMouseUp = () => { isResizingSideBySideRef.current = false; };
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      return () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };
    }, []);

    const handleSideBySideDragStart = (e) => {
      isResizingSideBySideRef.current = true;
      sideBySideDragStartXRef.current = e.clientX;
      sideBySideDragStartWidthRef.current = sideBySideLeftWidthRef.current;
      e.preventDefault();
    };

    // Dismiss the floating highlight button when clicking outside it
    useEffect(() => {
      const dismiss = (e) => {
        if (!e.target.closest('[data-highlight-btn]')) {
          setHighlightBtnPos(null);
        }
      };
      document.addEventListener('mousedown', dismiss);
      return () => document.removeEventListener('mousedown', dismiss);
    }, []);

    const handleStartEditTitle = (item) => {
      setEditingConsultationId(item.id);
      setEditedTitle(item.title);
      setEditChiefComplaint(true);
      handleMenuClose();
    };

    const handleSaveTitle = async () => {
      const success = await changeChiefComplaint(editingConsultationId, editedTitle);
      if (success) {
        setEditingConsultationId(null);
        setEditedTitle('');
        setEditChiefComplaint(false);
      }
    };

    const handleSaveConsultationTitle = async () => {
      if (isPopupReport && selectedReport?.id) {
        const success = await changeReportTitle(selectedReport.id, titleEditValue);
        if (success) setIsTitleEditing(false);
      } else {
        const consultation = currentConsultation?.id ? currentConsultation : await insertConsultation();
        if (!consultation?.id) return;
        const success = await changeChiefComplaint(consultation.id, titleEditValue);
        if (success) setIsTitleEditing(false);
      }
    };

    const openReportSetup = () => {
      setShowReportDialog(true);
      if (!writeSourcesEnabled) setMobilePane('report');
    };

    const generateWriteReportFromTemplate = template => {
      handleTemplateSelect(template);
      return generateWriteReport({ templateOverride: template });
    };
    const uploadAndGenerateWriteReport = async event => {
      const template = await handleUploadTemplate(event);
      if (template) await generateWriteReportFromTemplate(template);
    };

    const openHomeworkSetup = async () => {
      const template = await ensureHomeworkPracticeTemplate();
      if (!template) return;
      if (writeSourcesEnabled) return generateWriteReport({ templateOverride: template });
      return pendingRefineGate(() => regenerateReportConsultation(template));
    };

    const handleCancelEditTitle = () => {
      setEditingConsultationId(null);
      setEditedTitle('');
      setEditChiefComplaint(false);
    };

    const handleRecordingFileUpload = async (file) => {
      if (!isSupportedTranscriptionFile(file.name)) {
        setAlert('Please select a supported audio/video file (MP3, WAV, M4A, MP4, etc.)', 'warning');
        return;
      }
      const uploaded = await handlePatientFileUpload({ target: { files: [file] } });
      const uploadedItem = uploaded?.find(item => item.title === file.name && isSupportedTranscriptionFile(item.title));
      if (uploadedItem) setRecordingSelectedItem(uploadedItem);
    };

    const handleStartTranscription = async (languageOverride = null) => {
      if (!recordingSelectedItem) {
        setAlert('Please select or upload an audio/video file', 'warning');
        return;
      }
      const selectedLanguage = languageOverride || tempTranscriptionLanguage;
      if (!selectedLanguage) {
        setAlert('Please select a transcription language', 'warning');
        return;
      }
      setTranscriptionLanguage(selectedLanguage);
      const completed = await performAudioTranscription(recordingSelectedItem, selectedLanguage);
      if (!completed) return;
      setRecordingSelectedItem(null);
      setWorkflowMode('live-consultation');
    };

    const consultationPanelSx = {
      height: '80vh',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #E5E7EB',
      padding: '16px',
      marginBottom: '16px',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      position: 'relative',
    };

    const askSophieButtonSx = {
      position: 'absolute',
      top: 0,
      right: '5px',
      transform: 'translateY(-100%)',
    };

    const renderChatMessageList = () => {
      if (!chatMessages || chatMessages.length === 0) {
        return (
          <Stack
            spacing={3}
            sx={{
              flex: 1,
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              color: '#1f2933',
              py: 1,
            }}
          >
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Get more done with{' '}
                <Box
                  component="span"
                  sx={{
                    background: 'linear-gradient(90deg, #29C0BB 0%, #67D5C5 50%, #1ca8a4 100%)',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  Sophie
                </Box>
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 1, maxWidth: 320, mx: 'auto', color: '#4a5568' }}
              >
                Start the conversation to unlock quick insights, smarter summaries, and on-demand support.
              </Typography>
            </Box>
            <Box
              sx={{
                alignSelf: 'flex-end',
                backgroundColor: '#E8F4F4',
                color: '#1f2933',
                px: 2,
                py: 1.5,
                borderRadius: '16px 16px 4px 16px',
                boxShadow: '0px 1px 2px rgba(0,0,0,0.1)',
                maxWidth: '70%',
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                What can you do?
              </Typography>
            </Box>
            <Box
              sx={{
                alignSelf: 'flex-start',
                backgroundColor: '#F5F7FA',
                color: '#1f2933',
                px: 2,
                py: 2,
                borderRadius: '16px 16px 16px 4px',
                boxShadow: '0px 1px 2px rgba(0,0,0,0.1)',
                textAlign: 'left',
                maxWidth: 500,
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Sophie
              </Typography>
              <Typography variant="body2" component="div">
                I'm your AI assistant Sophie. I can help you with:
              </Typography>
              <Box
                component="ul"
                sx={{
                  pl: 2,
                  mt: 1,
                  mb: 1.5,
                  color: '#1f2933',
                  '& li': { marginBottom: '6px', fontSize: '0.9rem' },
                }}
              >
                <li>Editing the report you are working on</li>
                <li>Generate recommendations for intervention or follow-up</li>
                <li>
                  Answering questions about psychology using up-to-date information from web searches
                </li>
              </Box>
              <Typography variant="body2">Let me know how I can assist you!</Typography>
            </Box>
          </Stack>
        );
      }

      return chatMessages.map((msg, index) => (
        <Box
          key={index}
          sx={{
            alignSelf: msg.isUser ? 'flex-end' : 'flex-start',
            // A cut-off answer must never look like a finished one, so it gets
            // its own colour and rule as well as the notice line below.
            backgroundColor: msg.isUser ? '#E8F4F4' : msg.isTruncated ? '#FFFBEB' : '#F5F7FA',
            color: '#1f2933',
            padding: '10px 14px',
            borderRadius: msg.isUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
            ...(msg.isTruncated ? { borderLeft: '3px solid #D97706' } : {}),
            maxWidth: '80%',
            boxShadow: '0px 1px 2px rgba(0,0,0,0.1)',
            position: 'relative',
            transition: 'background-color 0.2s',
            '&:hover .chat-action-buttons': {
              opacity: msg.senderid === 'ai-assistant' ? 1 : 0,
              visibility: msg.senderid === 'ai-assistant' ? 'visible' : 'hidden',
            },
          }}
        >
          {msg.isProcessing ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                {msg.message}
              </Typography>
              <Box sx={{ display: 'flex', marginLeft: '4px' }}>
                <Box
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: '#29C0BB',
                    borderRadius: '50%',
                    animation: 'pulse 1.2s infinite ease-in-out',
                    animationDelay: '0s',
                    mx: 0.25,
                  }}
                />
                <Box
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: '#29C0BB',
                    borderRadius: '50%',
                    animation: 'pulse 1.2s infinite ease-in-out',
                    animationDelay: '0.3s',
                    mx: 0.25,
                  }}
                />
                <Box
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: '#29C0BB',
                    borderRadius: '50%',
                    animation: 'pulse 1.2s infinite ease-in-out',
                    animationDelay: '0.6s',
                    mx: 0.25,
                  }}
                />
              </Box>
            </Box>
          ) : (
            <>
              <Typography variant="body2" sx={{ padding: '0px 10px' }}>
                <div
                  style={msg.isStreaming ? { display: 'inline' } : undefined}
                  dangerouslySetInnerHTML={{
                    __html: msg.message.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>').replace(/\n/g, '<br />'),
                  }}
                />
                {/* Blinking caret: the answer is still arriving, so this is not
                    yet the whole thing. It disappears when `done` replaces the
                    text, or gives way to the cut-off notice if it never comes. */}
                {msg.isStreaming && (
                  <Box
                    component="span"
                    aria-hidden="true"
                    sx={{
                      display: 'inline-block',
                      width: '2px',
                      height: '1em',
                      ml: '2px',
                      verticalAlign: 'text-bottom',
                      backgroundColor: '#29C0BB',
                      animation: 'askSophieCaret 1s step-end infinite',
                      '@keyframes askSophieCaret': { '50%': { opacity: 0 } },
                    }}
                  />
                )}
              </Typography>

              {/* Truncated stream: the text above is a fragment. It is shown
                  because the doctor may already have read something useful, but
                  it was NOT written to the chat history — see
                  tikcare_rag docs/STREAMING-DESIGN.md §6.2. */}
              {msg.isTruncated && (
                <Box
                  sx={{
                    mt: 1,
                    mx: '10px',
                    px: 1,
                    py: 0.75,
                    borderRadius: '8px',
                    backgroundColor: '#FEF3C7',
                  }}
                >
                  <Typography variant="caption" sx={{ display: 'block', color: '#92400E', fontWeight: 600 }}>
                    {TRUNCATION_NOTICE}
                  </Typography>
                </Box>
              )}

              {/* Where the answer came from, on the face of the bubble: the sources
                  the answer actually cites ([n] in the text), collapsed by default
                  and opened in place — file + page, upload date and a snippet.
                  Nothing here for an answer that is still arriving or was cut
                  off, because a fragment's citations describe an answer nobody has. */}
              {hasVisibleSources(msg) && <SophieSources sources={msg.sources} />}

              {/* No copy / save-as-report on a bubble that is still arriving or
                  was cut off: saving a fragment as a report is the exact way a
                  half answer becomes a permanent clinical record. */}
              {msg.senderid === 'ai-assistant' && !msg.isProcessing && !msg.isStreaming && !msg.isTruncated && (
                <Box
                  className="chat-action-buttons"
                  sx={{
                    position: 'absolute',
                    right: '-50px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    opacity: 0,
                    visibility: 'hidden',
                    transition: 'opacity 0.2s, visibility 0.2s',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '8px',
                    padding: '4px',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                    zIndex: 10,
                  }}
                >
                  <Tooltip title="Copy message">
                    <IconButton
                      size="small"
                      data-track-id="consultation.transcript.copy_message"
                      onClick={() => {
                        navigator.clipboard
                          .writeText(msg.message)
                          .then(() => {
                            setAlert('Message copied to clipboard!', 'success');
                          })
                          .catch((err) => {
                            console.error('Failed to copy message: ', err);
                            setAlert('Failed to copy message', 'error');
                          });
                      }}
                      sx={{
                        width: '28px',
                        height: '28px',
                        color: '#29C0BB',
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                        },
                      }}
                    >
                      <CopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Save content as report">
                    <IconButton
                      size="small"
                      onClick={() => handleSaveChatMessageAsReport(msg.message)}
                      sx={{
                        width: '28px',
                        height: '28px',
                        color: '#29C0BB',
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                        },
                      }}
                    >
                      <SaveIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </>
          )}
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'text.secondary',
              fontSize: '0.7rem',
              textAlign: 'right',
            }}
          >
            {new Date(msg.created_at).toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' }) +
              ' ' +
              new Date(msg.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </Typography>
        </Box>
      ));
    };

    const reviewSources = selectedWriteSources.filter(canReviewOcr);
    const writeReviewPanel = writeSourcesEnabled && ocrOpenedInWrite.current && ocrItem ? <AttachmentOcrDialog key={ocrItem.path}
      item={ocrItem} inline autoRun={ocrAutoRun} queue={reviewSources.length ? reviewSources : ocrQueue} onDirtyChange={onSourceDirtyChange}
      onReviewStateChange={(path, ready) => setOcrGenerationReady(previous => previous.path === path && previous.ready === ready ? previous : { path, ready })}
      onSelectFile={path => { setOcrAutoRun(false); setOcrItem(reviewSources.find(item => item.path === path) || ocrQueue.find(item => item.path === path)); setOcrRefresh(value => value + 1); }}
      onClose={() => { setOcrItem(null); setOcrQueue([]); setOcrAutoRun(false); setOcrRefresh(value => value + 1); }}
      retrieveAttachmentFile={retrieveAttachmentFile} /> : null;

    // Write opens on a blank document to type in (Cath, 2026-10-13). It becomes a
    // Files entry on its first autosave; ticking files and Generate work as before.
    const showTypedDocument = writeSourcesEnabled && !selectedItems.length && !selectedWriteSources.length
      && writeDocument?.scopePatientId !== id && !writeReviewPanel;
    const [typedDocument, setTypedDocument] = useState(null);
    const typedDocumentRef = useRef(null);
    typedDocumentRef.current = typedDocument;
    const typedDocumentCreation = useRef(null);
    useEffect(() => { setTypedDocument(null); }, [id]);
    useEffect(() => {
      // A saved document stays in Files; coming back to an empty Write starts a new one.
      if (showTypedDocument && !typedDocument) setTypedDocument({ ...createTypedDocumentDraft(), scopePatientId: id });
      else if (!showTypedDocument && typedDocument?.created) setTypedDocument(null);
    }, [showTypedDocument, typedDocument, id]);
    const ensureTypedDocument = () => {
      const draft = typedDocumentRef.current;
      if (!draft || draft.created) return Promise.resolve();
      if (typedDocumentCreation.current?.id !== draft.id) {
        const promise = insertTypedDocument(supabase, { draft, patientId: draft.scopePatientId, userDetails }).then(item => {
          setHistoryItems(items => items.some(entry => entry.id === item.id) ? items : [item, ...items]);
          setTypedDocument(current => current?.id === item.id ? { ...current, created: true } : current);
        }, error => { typedDocumentCreation.current = null; throw error; });
        typedDocumentCreation.current = { id: draft.id, promise };
      }
      return typedDocumentCreation.current.promise;
    };
    const renameTypedDocument = async (reportId, title) => {
      const renamed = await changeReportTitle(reportId, title);
      if (renamed) setTypedDocument(current => current?.id === reportId ? { ...current, title: title.trim() } : current);
      return renamed;
    };
    const typedDocumentPanel = showTypedDocument && typedDocument?.scopePatientId === id
      // A Word-like page: the whole area is typeable, not just the first line.
      ? <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column', p: 2, '& .tiptap.ProseMirror': { minHeight: 'min(55vh, 520px)', cursor: 'text' } }}>
        <WriteReportDocument key={typedDocument.id} item={typedDocument} onDirtyChange={onSourceDirtyChange}
          idleStatus={typedDocument.created ? undefined : 'Start typing — saved automatically'} showEmptyNotice={false}
          onRename={typedDocument.created ? renameTypedDocument : undefined}
          onDownload={typedDocument.created ? () => handleDownloadReport(historyItems.find(entry => entry.id === typedDocument.id) || typedDocument) : undefined}
          ensureReport={ensureTypedDocument} onTemplateSaved={onTemplateSaved} userDetails={userDetails} currentOrg={currentOrg}
          patient_id={id} setHistoryItems={setHistoryItems} setSelectedText={setSelectedText} />
      </Box>
      : null;

    const writeSourceTitle = selectedWriteSources.length === 1
      ? selectedWriteSources[0].title
      : selectedWriteSources.length > 1 ? `${selectedWriteSources.length} files selected` : 'Choose files';
    const canGenerateWriteSourceReport = Boolean(selectedWriteSources.length) && !hasUnavailableReportSources(selectedWriteSources)
      && !sourcePreparation.summary.problems.length && !sourcePreparation.busy
      && !isGeneratingReport && !checkingWriteSources;
    const renderConsultationTab = layout => {
      // Keep the editors available before choosing or starting transcription.
      const showReportPane = writeSourcesEnabled
        ? Boolean(writeDocument?.scopePatientId === id)
        : true;
      const liveTranscribing = workflowMode === 'live-consultation' && isRecognizing && audioOption !== 'save_only';
      const showTranscriptPane = true;
      const filesOnly = layout.collapseFiles && sophieWorkspacePane === 'files' && workflowMode !== 'live-consultation';
      const filesVisible = showSidebar && (!layout.collapseFiles || filesOnly);
      const compactPane = showReportPane && sophieWorkspacePane !== 'source' ? 'report' : 'source';
      const sourceHidden = showReportPane && (layout.compactEditors ? compactPane : mobilePane) === 'report';
      const revealWorkspace = handler => (...args) => {
        setSophieWorkspacePane('report');
        return handler(...args);
      };
      const sourceWidth = showReportPane ? isChatOpen ? `min(${sideBySideLeftWidth}px, 42%)` : sideBySideLeftWidth : '100%';
      return (
      <ScribeThemeProvider><Grid size={12}>
      <RefineNavigationDialog open={Boolean(pendingTranscriptAction)} isRefining={isRefiningTranscript}
        isPending={isPendingRefinement} busy={transcriptActionBusy} onCancel={() => setPendingTranscriptAction(null)}
        onContinue={async () => {
            if (transcriptActionLock.current) return;
            transcriptActionLock.current = true;
            const action = pendingTranscriptAction;
            setTranscriptActionBusy(true);
            try { if (await saveTranscriptBeforeLeaving()) { setPendingTranscriptAction(null); await action(); } }
            finally { transcriptActionLock.current = false; setTranscriptActionBusy(false); }
        }} />
      {!firstView && (
        <>
          {writeSourcesEnabled && <ReportSourcePreparationPanel
            sources={selectedWriteSources} preparation={{ ...sourcePreparation, prepare: prepareWriteSources }}
            onRemove={sourceId => applyWriteSelection(selectedItems.filter(itemId => itemId !== sourceId))} />}
          {isRefiningTranscript && <Alert severity="info" icon={<CircularProgress size={18} />} sx={{ mb: 2 }}>Refining your transcript in the background. It will be saved to the original consultation. Keep this page open until saving finishes.</Alert>}
          {(isGeneratingReport || checkingWriteSources) && <Alert role="status" severity="info" icon={<CircularProgress size={18} />} sx={{ mb: 2 }}>
            {isGeneratingReport ? 'Generating report… Your report will appear here when it is ready.' : 'Preparing your sources… Please wait.'}
          </Alert>}
          <RecordedTranscriptionRecovery recovery={recordedTranscriptionRecovery} busy={savingConsultation}
            onCheckResult={async () => {
              if (await checkRecordedTranscriptionResult()) {
                setRecordingSelectedItem(null);
                setWorkflowMode('live-consultation');
              }
            }}
            onRetrySave={async () => {
              if (await retryRecordedTranscriptionSave()) {
                setRecordingSelectedItem(null);
                setWorkflowMode('live-consultation');
              }
            }} />
          {/* ===== WORKFLOW SELECTOR (collapsible) ===== */}
          <ConsultationWorkflowPicker filesToggleHidden={layout.collapseFiles} isRecognizing={isRecognizing} resetConsultationUI={resetConsultationUI} setShowSidebar={next => {
            if (layout.collapseFiles) {
              if (next) setShowSidebar(true);
              setSophieWorkspacePane(next ? 'files' : 'report');
            } else setShowSidebar(next);
          }} setShowWorkflowSelector={setShowWorkflowSelector} beforeChangeWorkflow={mode => {
            if (!checkSavedSources()) return false;
            if (workflowMode === 'live-consultation' && currentConsultation?.id && !isRecognizing && mode !== workflowMode) {
              runTranscriptAction(() => mode === 'write-document' ? openCurrentTranscriptInWrite() : setWorkflowMode(mode));
              return false;
            }
            return true;
          }} setWorkflowMode={setWorkflowMode} showSidebar={filesVisible} showWorkflowSelector={showWorkflowSelector} workflowMode={workflowMode} />

          {workflowMode && layout.collapseFiles && workflowMode !== 'live-consultation' && <Tabs
            value={filesOnly ? 'files' : layout.compactEditors ? compactPane : 'workspace'}
            onChange={(_, value) => { if (value === 'files') setShowSidebar(true); setSophieWorkspacePane(value); }}
            aria-label="Workspace content" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ mb: 2 }}>
            <Tab value="files" label="Files" />
            {layout.compactEditors ? <Tab value="source" label="Source text" /> : <Tab value="workspace" label="Workspace" />}
            {layout.compactEditors && showReportPane && <Tab value="report" label="Report" />}
          </Tabs>}
          {/* ===== MAIN CONTENT AREA (sidebar + content + AI assistant) ===== */}
          {workflowMode && (
          <Box sx={{ display: 'flex', gap: 2, minHeight: 'calc(100vh - 350px)', overflow: 'hidden' }}>

            {/* LEFT: Past Documents Sidebar */}
            {showSidebar && workflowMode !== 'live-consultation' && (
              <Box sx={{ display: filesVisible ? 'block' : 'none', flexShrink: 0, width: filesOnly ? '100%' : undefined }}>
              <ConsultationFilesPanel activeSection={writeSourcesEnabled ? writeFilesSection : undefined} onSectionChange={writeSourcesEnabled ? changeWriteFilesSection : undefined} activeDocumentId={writeSourcesEnabled ? activeWriteDocumentId : null} onOpenDocument={writeSourcesEnabled ? revealWorkspace(showWriteDocument) : undefined} onDeleteSelection={writeSourcesEnabled ? requestWriteDeletion : undefined} selectionScope={id} onApplySelection={writeSourcesEnabled ? revealWorkspace(applyWriteSelection) : undefined} onOcr={workflowMode === 'live-consultation' ? undefined : writeSourcesEnabled ? revealWorkspace(openWriteFile) : ATTACHMENT_OCR_ENABLED ? openGeneralOcr : undefined} anchorEl={anchorEl} consultationLoading={consultationLoading} convertToGMT8Date={convertToGMT8Date} deleteSelectedHistoryItems={deleteSelectedHistoryItems} editingConsultationId={editingConsultationId} fileInputRef={fileInputRef} getFilteredHistoryItems={getFilteredHistoryItems} handleDeleteItem={handleDeleteItem} handleDownloadReport={handleDownloadReport} handleMenuClose={handleMenuClose} handlePatientFileUpload={uploadWriteFiles} handleStartEditTitle={handleStartEditTitle} handleTranscribeAudio={handleTranscribeAudio} isSupportedTranscriptionFile={isSupportedTranscriptionFile} leftPanelWidth={filesOnly ? '100%' : leftPanelWidth} searchQuery={searchQuery} selectedItem={selectedItem} selectedItems={selectedItems} setAlert={setAlert} setOpenDialog={setOpenDialog} setPreviewItem={setPreviewItem} setPreviewOpen={setPreviewOpen} setRecordingSelectedItem={setRecordingSelectedItem} setSearchQuery={setSearchQuery} setShowPastDocs={next => { if (layout.collapseFiles && !next) setSophieWorkspacePane('report'); else setShowPastDocs(next); }} showPastDocs={showPastDocs} sortConfig={sortConfig} toggleItemSelection={toggleItemSelection} workflowMode={workflowMode} />
              </Box>
            )}

            {/* Panel resize handle — only shown when sidebar is visible */}
            {filesVisible && !filesOnly && workflowMode !== 'live-consultation' && (
              <Box
                onMouseDown={handlePanelDragStart}
                sx={{
                  width: 20,
                  flexShrink: 0,
                  cursor: 'col-resize',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mx: -0.75,
                  zIndex: 10,
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  position: 'relative',
                }}
              >
                <Box sx={{ position: 'absolute', top: 0, bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '1px', backgroundColor: '#C4C4C4' }} />
              </Box>
            )}

            {/* MIDDLE: Main Content Area */}
            <Box sx={{ flex: 1, display: filesOnly ? 'none' : 'flex', flexDirection: 'column', gap: 2, minWidth: 0, overflow: 'auto'}}>

              {/* Transcription Control Panel (Live Consultation mode) */}
              {workflowMode === 'live-consultation' && (
                <ConsultationLivePanel recordedTranscriptionRecovery={recordedTranscriptionRecovery} hasTranscript={Boolean(currentConsultation?.id && (transcription?.trim() || remarks?.trim()))}
                  patientName={patient?.name || `${patient?.firstName || ''} ${patient?.lastName || ''}`.trim() || 'this patient'}
                  saveStatus={transcriptSaveStatus} onRetrySave={saveTextOnly}
                  onContinueTranscription={() => isTeleHealthActive ? sttFromMic() : runTranscriptAction(sttFromMic)}
                  onOpenWrite={() => runTranscriptAction(openCurrentTranscriptInWrite)}
                  onChoosePatient={() => runTranscriptAction(() => navigate('/consultation'))}
                  isRefiningTranscript={isRefiningTranscript} onNewTranscription={() => runTranscriptAction(() => {
                    if (resetConsultationUI()) { setLastRecording(null); setRecordingSelectedItem(null); setShowControlPanel(true); }
                  })} isTeleHealthActive={isTeleHealthActive} setIsTeleHealthActive={setIsTeleHealthActive} audioOption={audioOption} inputSource={inputSource} inputSources={inputSources} isRecognizing={isRecognizing} liveRecognitionInterrupted={liveRecognitionInterrupted} liveSync={liveSync} liveConnectionWarning={liveConnectionWarning} isSettling={isSettling} isStarting={isStarting} startupStage={startupStage} isUploading={isUploading} isRecordingDragOver={isRecordingDragOver} language={language} languages={languages} transcriptionLanguage={tempTranscriptionLanguage} transcriptionLanguages={transcriptionLanguages} setTranscriptionLanguage={setTempTranscriptionLanguage} lastRecording={lastRecording} recordingSelectedItem={recordingSelectedItem} retryRecordingUpload={retryRecordingUpload} uploadProgress={uploadProgress} savingConsultation={savingConsultation || transcriptActionBusy} setAlert={setAlert} setAudioOption={setAudioOption} setInputSource={setInputSource} setIsRecordingDragOver={setIsRecordingDragOver} setLanguage={setLanguage} setLastRecording={setLastRecording} setRecordingSelectedItem={setRecordingSelectedItem} setSelectedAudioItemForTranscription={setSelectedAudioItemForTranscription} setSelectedMicId={setSelectedMicId} setShowControlPanel={setShowControlPanel} setShowTranscriptionLanguagePopup={setShowTranscriptionLanguagePopup} showControlPanel={showControlPanel} sttFromMic={sttFromMic} handleRecordingFileUpload={handleRecordingFileUpload} handleStartTranscription={handleStartTranscription} historyItems={historyItems} isSupportedTranscriptionFile={isSupportedTranscriptionFile} timer={timer} />
              )}


              {/* Write Document Control Panel */}
              {workflowMode === 'write-document' && (!writeSourcesEnabled || isPopupReport) && (
                <ConsultationWritePanel generateComprehensiveReport={generateWriteReport} handleTemplateSelect={handleTemplateSelect} handleUploadTemplate={handleUploadTemplate} isGeneratingReport={isGeneratingReport || checkingWriteSources} selectedItems={selectedItems} selectedTemplate={selectedTemplate} setShowControlPanel={setShowControlPanel} showControlPanel={showControlPanel} templates={templates} />
              )}

              {/* Transcribe Recording Control Panel */}
              {workflowMode === 'transcribe-recording' && (
                <ConsultationRecordingPanel recordedTranscriptionRecovery={recordedTranscriptionRecovery} transcriptionStage={transcriptionStage} fileUploadProgress={fileUploadProgress} handleRecordingFileUpload={handleRecordingFileUpload} handleStartTranscription={handleStartTranscription} historyItems={historyItems} isRecordingDragOver={isRecordingDragOver} isUploading={isUploading} recordingSelectedItem={recordingSelectedItem} savingConsultation={savingConsultation} setIsRecordingDragOver={setIsRecordingDragOver} setRecordingSelectedItem={setRecordingSelectedItem} setShowControlPanel={setShowControlPanel} setTempTranscriptionLanguage={setTempTranscriptionLanguage} showControlPanel={showControlPanel} tempTranscriptionLanguage={tempTranscriptionLanguage} transcriptionLanguages={transcriptionLanguages} />
              )}

              {/* ===== DOCUMENT TITLE BAR ===== */}
              {(() => {
                // Derive the active item for this bar based on current view state
                const fallbackTitle = workflowMode === 'live-consultation' ? 'Consultation' : 'Consultation Document';
                const titleBarTitle = isPopupReport
                  ? (selectedReport?.title || 'Document')
                  : workflowMode === 'live-consultation'
                    ? (currentConsultation?.chiefComplaint ? `Consultation · ${currentConsultation.chiefComplaint}` : fallbackTitle)
                  : (currentConsultation?.chiefComplaint || fallbackTitle);
                const canEditTitle = (isPopupReport && !!selectedReport?.id) || (!isPopupReport && !!currentConsultation?.id);
                const exportItem = latestConsultationReport || (isPopupReport ? selectedReport : null);

                return workflowMode === 'live-consultation' || (writeSourcesEnabled && !isPopupReport) ? null : (
                  <ConsultationTitleBar canEditTitle={canEditTitle} currentConsultation={currentConsultation} exportItem={exportItem} handleDownloadReport={handleDownloadReport} handleSaveConsultationTitle={handleSaveConsultationTitle} isPopupReport={isPopupReport} isTitleEditing={isTitleEditing} selectedReport={selectedReport} setIsTitleEditing={setIsTitleEditing} setTitleEditValue={setTitleEditValue} titleBarTitle={titleBarTitle} titleEditValue={titleEditValue} />
                );
              })()}


              {/* ===== TWO-COLUMN CONTENT GRID ===== */}
              {isPopupReport ? (
                <Box sx={{ flex: 1, display: 'flex' }}>
                  <ReportSummaryView onTemplateSaved={onTemplateSaved}
                    regenerateHistoryReport={regenerateHistoryReport}
                    selectedReport={selectedReport}
                    setSelectedReport={setSelectedReport}
                    handleCopy={handleCopy}
                    extractParagraphText={extractParagraphText}
                    setPopupReport={setPopupReport}
                    handleBackToTemplateSelector={handleBackToTemplateSelector}
                    userDetails={userDetails}
                    setSelectedText={setSelectedText}
                    selectedText={selectedText}
                    files={reportDocs}
                    handleRetrieveText={handleTextHighlight}
                    retrievedData={highlightedTexts}
                    setHistoryItems={setHistoryItems}
                    handleDownloadItem={handleDownloadReport}
                    setPopupPdfFill={setPopupPdfFill}
                    currentOrg={currentOrg}
                    patient_id={id}
                    chatMessages={chatMessages}
                    newMessage={newMessage}
                    setNewMessage={setNewMessage}
                    handleSendMessage={handleSendMessage}
                    isChatOpen={isChatOpen}
                    setIsChatOpen={setIsChatOpen}
                    chatBoxRef={chatBoxRef}
                    answerSource={answerSource}
                    setAnswerSource={setAnswerSource}
                    isAnswerSourceOpen={isAnswerSourceOpen}
                    setIsAnswerSourceOpen={setIsAnswerSourceOpen}
                    setAlert={setAlert}
                    responseSources={responseSources}
                    setResponseSources={setResponseSources}
                    openSource={openSource}
                    setOpenSource={setOpenSource}
                    handleSaveChatMessageAsReport={handleSaveChatMessageAsReport}
                    highlightMode={highlightMode}
                    setHighlightMode={setHighlightMode}
                    templates={templates}
                    selectedTemplate={selectedTemplate}
                    handleTemplateSelect={handleTemplateSelect}
                    handleUploadTemplate={handleUploadTemplate}
                    isGeneratingReport={isGeneratingReport}
                  />
                </Box>
              ) : (
                <>
                {showReportPane && (workflowMode === 'live-consultation' || writeSourcesEnabled) && <Tabs value={layout.compactEditors ? compactPane : mobilePane} onChange={(_, value) => layout.compactEditors ? setSophieWorkspacePane(value) : setMobilePane(value)} aria-label="Consultation content" variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ display: layout.collapseFiles && workflowMode !== 'live-consultation' ? 'none' : layout.compactEditors ? 'flex' : { xs: 'flex', md: 'none' }, minHeight: 42, '& .MuiTab-root': { minHeight: 42, textTransform: 'none' } }}><Tab value="source" label={writeSourcesEnabled ? 'Source text' : 'Transcription'} /><Tab value="report" label="Report" /></Tabs>}
                {(writeSourcesEnabled || showTranscriptPane || showReportPane) && <Box ref={sideBySideContainerRef} sx={{ flex: 1, display: 'flex', flexDirection: layout.compactEditors ? 'column' : { xs: 'column', md: 'row' }, gap: 2, maxHeight: { xs: 'none', md: writeSourcesEnabled && !showReportPane ? 'none' : 620 }, height: { md: writeReviewPanel && !showReportPane ? 'max(540px, calc(100vh - 230px))' : undefined }, minHeight: writeSourcesEnabled && !showReportPane ? 'calc(100vh - 300px)' : 520, scrollMarginTop: '88px' }}>
                  {/* LEFT COLUMN: Transcript */}
                  {(writeSourcesEnabled || showTranscriptPane) && (writeSourcesEnabled ? <WriteSourcePanel reportEditorProps={{ onTemplateSaved, userDetails, currentOrg, patient_id: id, setHistoryItems, setSelectedText, onRename: changeReportTitle, onDownload: handleDownloadReport }} retrieveFile={retrieveAttachmentFile} key={id} compact={layout.compactEditors} mobileHidden={sourceHidden} onSaveConsultation={saveSelectedConsultationSource} onDirtyChange={onSourceDirtyChange} width={sourceWidth} items={selectedWriteSources} refresh={ocrRefresh} reportMode={Boolean(writeDocument?.scopePatientId === id)} reviewPanel={(writeFilesSection === 'sources' ? writeReviewPanel : null) || typedDocumentPanel} sourceCheckResult={writeSourceCheckResult} onOcr={openWriteOcr} onOpen={openWriteFile} consultationTitle={writeSourceTitle} onGenerateReport={openReportSetup} onGenerateHomework={openHomeworkSetup} reportTemplates={templates.filter(template => !isHomePracticeTitle(template.title))} onSelectReportTemplate={generateWriteReportFromTemplate} onUploadReportTemplate={uploadAndGenerateWriteReport} canGenerateReport={canGenerateWriteSourceReport} generationHint={selectedWriteSources.length && ocrItem && (ocrGenerationReady.path !== ocrItem.path || !ocrGenerationReady.ready) ? 'OCR text is saving automatically. Report actions will be available shortly.' : undefined} isGeneratingReport={isGeneratingReport || checkingWriteSources} /> : <ConsultationTranscriptPanel userDetails={userDetails} onTemplateSaved={onTemplateSaved} compact={layout.compactEditors} mobileHidden={sourceHidden} RefiningTranscriptIndicator={RefiningTranscriptIndicator} RemarksMenuBar={RemarksMenuBar} acceptRefinement={acceptRefinement} applyStreamingSpeakerLabels={applyStreamingSpeakerLabels} canGenerateReport={!isGeneratingReport && !isRecognizing && !isSettling && Boolean(transcription?.trim() || remarks?.trim())} clearHighlights={clearHighlights} consultationTitle={workflowMode === 'live-consultation' ? (currentConsultation?.chiefComplaint || `Consultation · ${consultationSessionDate(currentConsultation)}`) : undefined} currentHighlightIndex={currentHighlightIndex} discardRefinement={discardRefinement} exportItem={latestConsultationReport} handleCopy={handleCopy} handleDownloadReport={handleDownloadReport} handleLeftViewChange={handleLeftViewChange} highlightCount={highlightCount} highlightedTexts={highlightedTexts} isPendingRefinement={isPendingRefinement} isRefiningTranscript={isRefiningTranscript} isTitleEditing={isTitleEditing} leftOptions={leftOptions} leftView={leftView} navigateToNextHighlight={navigateToNextHighlight} navigateToPreviousHighlight={navigateToPreviousHighlight} onBeginTitleEdit={() => { setIsTitleEditing(true); setTitleEditValue(currentConsultation?.chiefComplaint || ''); }} onCancelTitleEdit={() => setIsTitleEditing(false)} onGenerateReport={undefined} onGenerateHomework={undefined} onViewReport={undefined} onSaveTitle={handleSaveConsultationTitle} refineTranscriptError={refineTranscriptError} refineTranscriptFailure={refineTranscriptFailure} noSpeechDetected={noSpeechDetected} isLiveTranscribing={liveTranscribing} refinedPreview={refinedPreview} remarks={remarks} remarksEditor={remarksEditor} renderHighlightedTranscription={renderHighlightedTranscription} saveTextOnly={saveTextOnly} setAlert={setAlert} setRefinedPreview={setRefinedPreview} setTitleEditValue={setTitleEditValue} setTranscription={setTranscription} sideBySideLeftWidth={sourceWidth} textFieldRef={textFieldRef} titleEditValue={titleEditValue} transcription={transcription} transcriptionTextFieldRef={transcriptionTextFieldRef} />)}

                  {showReportPane && <>
                  {/* Side-by-side resize handle */}
                  <Box
                    onMouseDown={handleSideBySideDragStart}
                    sx={{
                      width: 20,
                      flexShrink: 0,
                      cursor: 'col-resize',
                      display: layout.compactEditors ? 'none' : { xs: 'none', md: 'flex' },
                      alignItems: 'center',
                      justifyContent: 'center',
                      mx: -0.75,
                      zIndex: 10,
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      position: 'relative',
                    }}
                  >
                    <Box sx={{ position: 'absolute', top: 0, bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '1px', backgroundColor: '#C4C4C4' }} />
                  </Box>

                  {/* RIGHT COLUMN: Document */}
                  <ScribePanel
                    sx={{ flex: 1, display: layout.compactEditors ? compactPane === 'source' ? 'none' : 'flex' : { xs: mobilePane === 'source' && (workflowMode === 'live-consultation' || writeSourcesEnabled) ? 'none' : 'flex', md: 'flex' }, flexDirection: 'column', minWidth: 0, overflow: 'hidden' }}
                  >
                    {workflowMode === 'live-consultation' && <ConsultationReportDialog
                      inline open={showReportDialog}
                      onClose={() => setShowReportDialog(false)}
                      templates={templates} selectedTemplate={selectedTemplate}
                      canGenerate={writeSourcesEnabled ? canGenerateWriteSourceReport : !isRecognizing && !isSettling && Boolean(transcription?.trim() || remarks?.trim())}
                      sourceLabel={writeSourcesEnabled ? `${selectedWriteSources.length} ${selectedWriteSources.length === 1 ? 'file' : 'files'} selected for this report` : 'Transcription and manual notes'}
                      reportDate={reportDateSelection}
                      onReportDateChange={setReportDateSelection}
                      onSelectTemplate={templateId => {
                        const template = templates.find(item => item.id === templateId);
                        if (template) handleTemplateSelect(template);
                      }}
                      onUploadTemplate={handleUploadTemplate}
                      isGenerating={isGeneratingReport || checkingWriteSources || isRefiningTranscript}
                      isRefiningTranscript={isRefiningTranscript && !isGeneratingReport}
                      onGenerate={() => {
                        if (writeSourcesEnabled) {
                          generateWriteReport().then(result => { if (result) setShowReportDialog(false); });
                        } else {
                          setShowReportDialog(false);
                          pendingRefineGate(() => regenerateReportConsultation());
                        }
                      }}
                    />}
                    {((writeSourcesEnabled && writeDocument?.scopePatientId === id) || workflowMode === 'live-consultation') && !showReportDialog && <WriteReportActions collapsible
                      canGenerate={writeSourcesEnabled ? canGenerateWriteSourceReport && !ocrItem : !isRecognizing && !isSettling && !isRefiningTranscript && Boolean(transcription?.trim() || remarks?.trim())}
                      isGenerating={isGeneratingReport || checkingWriteSources || isRefiningTranscript}
                      isRefiningTranscript={isRefiningTranscript && !isGeneratingReport}
                      selectedTemplate={selectedTemplate} templates={templates}
                      reportDate={reportDateSelection} onReportDateChange={setReportDateSelection}
                      onSelectTemplate={templateId => {
                        const template = templates.find(item => item.id === templateId);
                        if (template) handleTemplateSelect(template);
                      }}
                      onUploadTemplate={handleUploadTemplate}
                      onGenerate={() => writeSourcesEnabled ? generateWriteReport() : pendingRefineGate(() => regenerateReportConsultation())}
                      onGenerateHomework={openHomeworkSetup} />}
                    {workflowMode !== 'live-consultation' && !writeSourcesEnabled && <>
                    {/* Document tabs header */}
                    <Box sx={{ px: 1.5, py: 1, borderBottom: '1px solid #E5E7EB', backgroundColor: '#F9FAFB', borderRadius: '12px 12px 0 0' }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          sx={{ 
                            mt: 1, 
                            flexShrink: 0, 
                            justifyContent: 'space-between', 
                            width: '100%',
                            flexWrap: 'wrap',
                            gap: 1.5
                          }}
                        >
                          {/* Template dropdown */}
                          <MuiSelect
                            size="small"
                            value={selectedTemplate?.id || ''}
                            onChange={(e) => {
                              const t = templates.find(tmpl => tmpl.id === e.target.value);
                              if (t) handleTemplateSelect(t);
                            }}
                            displayEmpty
                            sx={{ minWidth: 160, maxWidth: 260, fontSize: '0.875rem' }}
                          >
                            <MenuItem disabled value="">
                              <em>{templates.length === 0 ? "No templates" : "Select Template"}</em>
                            </MenuItem>
                            {templates.map(t => (
                              <MenuItem key={t.id} value={t.id}>{t.title}</MenuItem>
                            ))}
                          </MuiSelect>

                          <Stack direction="row" alignItems="center" sx={{ flexWrap: 'wrap', gap: 1 }}>
                          {/* Upload template */}
                          <Button
                            component="label"
                            variant="outlined"
                            size="small"
                            sx={{
                              textTransform: 'none',
                              borderRadius: '8px',
                              fontWeight: 600,
                              fontSize: '0.8rem',
                              borderColor: '#D1D5DB',
                              color: '#374151',
                              '&:hover': { borderColor: '#9CA3AF', backgroundColor: '#F9FAFB' },
                            }}
                          >
                            Upload Template
                            <input type="file" hidden accept=".txt,.docx,.pdf" onChange={handleUploadTemplate} />
                          </Button>
                          {/* Generate — disabled while a refinement streams; gated
                              behind a confirm while a refined transcript is unsaved */}
                          <Tooltip title={isRefiningTranscript ? 'Refining transcript… please wait' : ''}>
                            <span>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={isGeneratingReport ? <CircularProgress size={14} color="inherit" /> : <AutoAwesomeIcon sx={{ fontSize: 20 }} />}
                            disabled={!selectedTemplate || isGeneratingReport || checkingWriteSources || (writeSourcesEnabled ? !selectedItems.length : isRefiningTranscript || (workflowMode === 'live-consultation' && (isRecognizing || isSettling || !(transcription?.trim() || remarks?.trim()))))}
                            onClick={() => writeSourcesEnabled ? generateWriteReport() : pendingRefineGate(() => regenerateReportConsultation())}
                            sx={{
                              backgroundColor: '#7C3AED',
                              '&:hover': { backgroundColor: '#6D28D9' },
                              '&.Mui-disabled': { backgroundColor: '#DDD6FE', color: '#7C3AED' },
                              textTransform: 'none',
                              borderRadius: '8px',
                              fontWeight: 600,
                              fontSize: '0.75rem',
                              flexShrink: 0,
                              whiteSpace: 'nowrap',
                              px: 2.5,
                            }}
                          >
                            {isGeneratingReport ? 'Generating...' : 'Generate'}
                          </Button>
                            </span>
                          </Tooltip>
                        </Stack>
                          </Stack>
                  </Box>
                    </>}
                    {/* Right column content area */}
                    <Box sx={{ flex: 1, overflow: 'auto', p: 2, display: 'flex', flexDirection: 'column' }}>
                      {workflowMode === 'live-consultation' && sectionSummary.id && <ConsultationReportHeader
                        item={latestConsultationReport || { id: sectionSummary.id, title: 'Report' }}
                        onRename={changeReportTitle}
                        onDownload={latestConsultationReport ? () => handleDownloadReport(latestConsultationReport) : undefined}
                        share={reportShare(latestConsultationReport)}
                        tools={{ ...liveReportTools.tools, canCheckSources: true }} />}
                      {/* Uploaded files */}
                      {/* {files.length > 0 && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
                          {files.map((file, index) => (
                            <Chip
                              key={index}
                              label={file.name}
                              onDelete={() => removeFile(file)}
                              onClick={() => downloadFile(file)}
                              sx={{
                                backgroundColor: '#F0FDFA',
                                color: '#0D9488',
                                fontWeight: 500,
                                fontSize: '0.75rem',
                                '& .MuiChip-deleteIcon': { color: '#0D9488', '&:hover': { color: '#DC2626' } },
                                cursor: 'pointer',
                              }}
                            />
                          ))}
                        </Box>
                      )} */}
                      {writeSourcesEnabled && writeDocument?.scopePatientId === id ? <WriteReportDocument onTemplateSaved={onTemplateSaved} key={writeDocument.id}
                        item={historyItems.find(item => item.id === writeDocument.id) || writeDocument}
                        onDirtyChange={onSourceDirtyChange}
                        onRename={changeReportTitle} onDownload={() => handleDownloadReport(historyItems.find(item => item.id === writeDocument.id) || writeDocument)}
                        share={reportShare(writeDocument)}
                        onCheckSources={checkSelectedReportSources} checkingSources={retrieving} userDetails={userDetails} setSelectedText={setSelectedText} setHistoryItems={setHistoryItems}
                        currentOrg={currentOrg} patient_id={id} highlightMode={highlightMode} /> : sectionSummary.id ? (
                        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                          <TemplateView onTemplateSaved={onTemplateSaved}
                            onCheckSources={query => handleTextHighlight({ query })} checkingSources={retrieving} handleBack={handleBackToTemplateSelector}
                            reportId={sectionSummary.id}
                            reportTools={workflowMode === 'live-consultation' ? liveReportTools.editorTools : undefined}
                            reportContent={sectionSummary.content}
                            userDetails={userDetails}
                            view="report"
                            edit={true}
                            setEdit={setEditNote}
                            sectionSummary={sectionSummary}
                            setSelectedText={setSelectedText}
                            setHistoryItems={setHistoryItems}
                            reportTitle={rightView}
                            setSelectedReport={null}
                            setSectionSummary={setSectionSummary}
                            currentOrg={currentOrg}
                            patient_id={id}
                            highlightMode={highlightMode}
                          />
                        </Box>
                      ) : (
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5, py: 4 }}>
                          <DescriptionIcon sx={{ fontSize: 40, color: '#D1D5DB' }} />
                          <ScribeText kind="section" sx={{ color: ui.colors.secondary }}>{writeSourcesEnabled ? 'Your document starts here' : 'No report yet'}</ScribeText>
                          <Typography variant="caption" sx={{ color: '#667085', textAlign: 'center', maxWidth: 260 }}>
                            {writeSourcesEnabled ? 'Review your sources, choose a template, then generate your document.' : 'Add a transcript or notes to generate a report.'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </ScribePanel>
                  </>}
                </Box>}
                </>
              )}

            </Box>

          </Box>
          )}
        </>
      )}
      {
        isPopupPdfFill && (
          <PopupMenu width="80%" height="70%">
            <PDFFormUploader 
              onClose={() => { setPopupPdfFill(false) }} 
              medicalData={isPopupReport ? selectedReport.originalData.content : sectionSummary.content}
              extractParagraphText={extractParagraphText}
            />
          </PopupMenu>
        )
      }
      {
        popupPatientInsights && (
          <PopupMenu>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '16px' }}>
              <Typography variant="h5">Client Insights</Typography>
              <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>   
                <Tooltip title="Copy Client Insights">
                  <IconButton onClick={() => { handleCopy(`Patient Insights \n\n\n${patientsInsightsData}`) }}>
                    <CopyIcon />
                  </IconButton>  
                </Tooltip>
                <Tooltip title="Regenerate Client Insights">
                  <IconButton 
                    onClick={() => { 
                      setPatientsInsightsData(''); 
                      generatePatientInsights(true); 
                    }}
                    disabled={patientInsightsLoading}
                  >
                    <RotateLeftIcon />
                  </IconButton>
                </Tooltip>
                {
                  !editPatientInsight && (
                    <Tooltip title="Edit Client Insights">
                      <IconButton 
                        onClick={() => { setEditPatientInsight(true); }}
                        disabled={patientInsightsLoading}
                      >
                        <EditIcon/>
                      </IconButton> 
                    </Tooltip>
                  )
                }
                {
                  editPatientInsight && (
                    <>
                      <Tooltip title="Save Client Insights">
                        <IconButton 
                          onClick={async () => { 
                            const success = await updatePatientInsights();
                            if (success) {
                              setEditPatientInsight(false);
                            }
                          }}
                          disabled={patientInsightsLoading}
                        >
                          <SaveIcon/>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Cancel Editing">
                        <IconButton 
                          onClick={() => { 
                            setEditPatientInsight(false);
                            // Reset to original data if user cancels
                            if (patient && patient.insights) {
                              setPatientsInsightsData(patient.insights);
                            }
                          }}
                          disabled={patientInsightsLoading}
                        >
                          <CloseIcon/>
                        </IconButton>
                      </Tooltip>
                    </>
                  )
                }                          
                <Box 
                  onClick={() => {
                    setPopupPatientInsights(false);
                    setEditPatientInsight(false);
                  }} 
                  sx={{ 
                    borderRadius: 30, 
                    backgroundColor: '#F8F9FA', 
                    padding: '5px 10px', 
                    color: "#29C0BB", 
                    cursor: 'pointer'
                  }}
                >
                  Close
                </Box>
              </Stack>
            </Stack>
            
            {editPatientInsight ? (
              <TextField
                multiline
                fullWidth
                minRows={10}
                maxRows={20}
                value={patientsInsightsData}
                onChange={(e) => setPatientsInsightsData(e.target.value)}
                placeholder="Edit client insights here..."
                variant="outlined"
                sx={{ 
                  backgroundColor: '#f9f9f9',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#29C0BB',
                    },
                    '&:hover fieldset': {
                      borderColor: '#1ca8a4',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#29C0BB',
                    },
                  }
                }}
              />
            ) : (
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ 
                  backgroundColor: '#f5f5f5', 
                  marginBottom: '20px', 
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  minHeight: '200px',
                  whiteSpace: 'pre-wrap',
                  fontFamily: 'monospace',
                  fontSize: '14px',
                  lineHeight: 1.6
                }} 
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: patientsInsightsData.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>').replace(/\n/g, '<br />')
                  }}
                />
              </Typography>
            )}
          </PopupMenu>
        )
      }
      {
          (loading || savingConsultation || patientInsightsLoading || retrieving || piiWarming) && (
            <PopupMenu>
              <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
                <Typography variant="h6">{piiWarming ? 'Starting AI Service' : loading ? 'Generating Report' : transcriptionStage ? transcriptionStageLabel(transcriptionStage) : savingConsultation ? 'Saving Consultation' : retrieving ?  'Retrieving Text' : 'Generating Client Insights '}</Typography>
                {piiWarming && (
                  <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', maxWidth: 360 }}>
                    The AI service is warming up — this can take about a minute. Your report will start automatically.
                  </Typography>
                )}
                {transcriptionStage ? <RecordingProgress stage={transcriptionStage} /> : <Loader />}
              </Stack>
            </PopupMenu>)
      }
      {
        openDialog && (
          <AlertDialog data={{open: openDialog.open, content: openDialog.content, confirmAction: openDialog.confirmAction, setOpen: setOpenDialog}}/>
        )
      }


      {/* Template Selector PopupMenu */}
      {showTemplateSelector && !showTemplateEditor && (
        <PopupMenu width="80%" height="75%">
          {templatesLoading ? (
            // Loading state
            <Grid container spacing={2} sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Grid size={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress size={60} sx={{ color: '#29C0BB', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#29C0BB', textAlign: 'center' }}>
                  Loading Templates...
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mt: 1 }}>
                  Please wait while we fetch your templates
                </Typography>
              </Grid>
            </Grid>
          ) : (
            // Existing template content
          <Grid container spacing={2} >
            {/* Left panel - Template list */}
            <Grid size={{xs: 12, md: 8}} sx={{ height: '100%', overflowY: 'auto' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Select a template</Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={() => setShowTemplateEditor(true)}
                  sx={{ 
                    backgroundColor: '#29C0BB', 
                    '&:hover': { backgroundColor: '#1ca8a4' } 
                  }}
                >
                  Create new template
                </Button>
              </Box>
              
              {/* Templates table */}
              <Box sx={{ width: '100%', overflowX: 'auto' }}>
                <MuiTable sx={{ minWidth: 400 }}>
                  <MuiTableHead>
                    <MuiTableRow sx={{ borderBottom: '1px solid #ddd' }}>
                      <MuiTableCell sx={{ padding: '8px', textAlign: 'left' }}>
                        <Box 
                          sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => requestTemplateSort('updated_at')}
                        >
                          Last updated
                          {templateSortConfig.key === 'updated_at' && (
                            templateSortConfig.direction === 'asc' 
                              ? <ArrowUpwardIcon fontSize="small" sx={{ ml: 1 }} /> 
                              : <ArrowDownwardIcon fontSize="small" sx={{ ml: 1 }} />
                          )}
                        </Box>
                      </MuiTableCell>
                      <MuiTableCell sx={{ padding: '8px', textAlign: 'left' }}>
                        <Box 
                          sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => requestTemplateSort('title')}
                        >
                          Template name
                          {templateSortConfig.key === 'title' && (
                            templateSortConfig.direction === 'asc' 
                              ? <ArrowUpwardIcon fontSize="small" sx={{ ml: 1 }} /> 
                              : <ArrowDownwardIcon fontSize="small" sx={{ ml: 1 }} />
                          )}
                        </Box>
                      </MuiTableCell>
                      <MuiTableCell sx={{ padding: '8px', textAlign: 'left' }}>Template type</MuiTableCell>
                      <MuiTableCell sx={{ padding: '8px', textAlign: 'left' }}>
                        <Box 
                          sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            cursor: 'pointer' 
                          }}
                          onClick={() => requestTemplateSort('created_by')}
                        >
                          Created by
                          {templateSortConfig.key === 'created_by' && (
                            templateSortConfig.direction === 'asc' 
                              ? <ArrowUpwardIcon fontSize="small" sx={{ ml: 1 }} /> 
                              : <ArrowDownwardIcon fontSize="small" sx={{ ml: 1 }} />
                          )}
                        </Box>
                      </MuiTableCell>
                    </MuiTableRow>
                  </MuiTableHead>
                  <MuiTableBody>
                    {templates.map((template) => (
                      <MuiTableRow 
                        key={template.id}
                        onClick={() => handleTemplateSelect(template)}
                        sx={{ 
                          cursor: 'pointer', 
                          backgroundColor: selectedTemplate?.id === template.id
                            ? '#e3f2fd' 
                            : 'inherit',
                          borderBottom: '1px solid #eee'
                        }}
                      >
                        <MuiTableCell sx={{ padding: '8px' }}>
                          {new Date(template.updated_at).toLocaleDateString()}
                        </MuiTableCell>
                        <MuiTableCell sx={{ padding: '8px' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {templateDisplayTitle(template.title)}
                            {/* {selectedTemplate?.id === template.id && (
                              <Chip 
                                label="Default" 
                                size="small" 
                                sx={{ ml: 1, backgroundColor: '#29C0BB', color: 'white' }}
                              />
                            )} */}
                          </Box>
                        </MuiTableCell>
                        <MuiTableCell sx={{ padding: '8px' }}>Note</MuiTableCell>
                        <MuiTableCell sx={{ padding: '8px' }}>{template.created_by}</MuiTableCell>
                      </MuiTableRow>
                    ))}
                    {templates.length === 0 && (
                      <MuiTableRow>
                        <MuiTableCell colSpan={4} sx={{ padding: '16px', textAlign: 'center' }}>
                          No templates found. Create a new one!
                        </MuiTableCell>
                      </MuiTableRow>
                    )}
                  </MuiTableBody>
                </MuiTable>
              </Box>
            </Grid>
            
            {/* Right panel - Template preview */}
            <Grid size={{xs: 12, md: 4}} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom>Preview</Typography>
              <Stack direction="column" alignItems="space-between" justifyContent="center" spacing={8} sx={{ flex: 1 }}>
                {/* Template preview */}
                <Box sx={{ flex: 1, overflowY: 'auto', mb: 2 }}>
                  <Box 
                    sx={{ 
                      border: '1px solid #ddd', 
                      borderRadius: 1, 
                      p: 2, 
                      minHeight: '200px',
                      maxHeight: '300px',
                      overflowY: 'auto',
                      '& .ProseMirror': {
                        minHeight: '300px',
                        outline: 'none',
                        '& img': {
                          maxWidth: '100%',
                          height: 'auto',
                        },
                        '& table': {
                          borderCollapse: 'collapse',
                          tableLayout: 'fixed',
                          width: '100%',
                          margin: '1rem 0',
                          position: 'relative',
                        },
                        '& td, & th': {
                          border: '1px solid black',
                          padding: '0.5rem',
                          position: 'relative',
                          verticalAlign: 'top',
                          textAlign: 'left',
                        },
                        '& th': {
                          backgroundColor: '#f5f5f5',
                          fontWeight: 'bold'
                        },
                      }
                    }}
                  >
                    {selectedTemplate ? (
                      <EditorContent editor={templateEditor} />
                    ) : (
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Select a template to preview its content
                      </Typography>
                    )}
                  </Box>
                </Box>
                
                {/* Buttons */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'space-between', justifyContent: 'space-between', gap: 2 }}>
                  {/* Consultation generate is disabled while a refinement streams and
                      gated while a refined transcript is unsaved; the comprehensive
                      report path (selectingReportTemplate) is not affected. */}
                  <Tooltip title={!selectingReportTemplate && isRefiningTranscript ? 'Refining transcript… please wait' : ''}>
                    <Box component="span" sx={{ display: 'flex' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={!selectedTemplate || (!selectingReportTemplate && isRefiningTranscript)}
                    onClick={() => {
                      if(selectingReportTemplate) {
                        setShowTemplateSelector(false);
                        generateWriteReport();
                      } else {
                        setShowTemplateSelector(false);
                        pendingRefineGate(() => generateReportFromConsultation(selectedTemplate));
                      }
                    }}
                    sx={{
                      backgroundColor: '#29C0BB',
                      '&:hover': { backgroundColor: '#1ca8a4' }
                    }}
                  >
                    {(!transcription || transcription.trim() === '') && (!remarks || remarks.trim() === '' || remarks === '<p></p>') && !sectionSummary.id && !selectingReportTemplate ? 'Select' : 'Generate'}
                  </Button>
                    </Box>
                  </Tooltip>
                  <Button 
                    variant="outlined"
                    onClick={() => {setShowTemplateSelector(false); setSelectedTemplate(defaultTemplate);}}
                  >
                    Cancel
                  </Button>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          )}
        </PopupMenu>
      )}
      
      {/* Template Editor View */}
      {showTemplateSelector && showTemplateEditor && (
        <PopupMenu>
          <TemplateView 
            onCheckSources={query => handleTextHighlight({ query })} checkingSources={retrieving} handleBack={handleBackToTemplateSelector}
            templateId={null}
            userDetails={userDetails}
            view="template"
          />
        </PopupMenu>
      )}

      {showTranscriptionLanguagePopup && (
        <PopupMenu width="500px" height="auto">
          <Stack spacing={3} sx={{ p: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" sx={{ color: '#29C0BB', fontWeight: 'bold' }}>
                Select Transcription Language
              </Typography>
            </Stack>

            <Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Select the language of the audio file to transcribe:
              </Typography>
              
              <SearchableSingleSelect
                label="Transcription Language"
                options={transcriptionLanguages}
                value={tempTranscriptionLanguage}
                onChange={(e) => setTempTranscriptionLanguage(e.target.value)}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                placeholder="Search or select a language..."
                required
              />
              <Typography variant="caption" sx={{ display: 'block', mt: 1.5, color: '#667085' }}>
                {CREDIT_COSTS.recordedTranscriptionPerHour} credit / 1 hour, billed in started 30-minute blocks. Transcription starts when you confirm.
              </Typography>
            </Box>

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                variant="outlined"
                onClick={() => {
                  setShowTranscriptionLanguagePopup(false);
                  setSelectedAudioItemForTranscription(null);
                }}
                sx={{
                  borderColor: '#29C0BB',
                  color: '#29C0BB',
                  '&:hover': {
                    borderColor: '#1ca8a4',
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  if (!tempTranscriptionLanguage) {
                    setAlert('Please select a transcription language', 'warning');
                    return;
                  }
                  setTranscriptionLanguage(tempTranscriptionLanguage);
                  performAudioTranscription(selectedAudioItemForTranscription, tempTranscriptionLanguage);
                  setShowTranscriptionLanguagePopup(false);
                }}
                disabled={!tempTranscriptionLanguage}
                sx={{
                  backgroundColor: '#29C0BB',
                  '&:hover': { backgroundColor: '#1ca8a4' },
                  '&.Mui-disabled': {
                    backgroundColor: '#d0d5dd',
                    color: '#ffffff'
                  }
                }}
              >
                Transcribe
              </Button>
            </Stack>
          </Stack>
        </PopupMenu>
      )}


      <Dialog
        open={saveReportDialog.open}
        onClose={() => setSaveReportDialog({ open: false, messageContent: '', onConfirm: null })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Save as Report</Typography>
            <IconButton 
              onClick={() => setSaveReportDialog({ open: false, messageContent: '', onConfirm: null })} 
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to save this AI message as a client report?
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            This will create a new document in the client's history that can be viewed and edited.
          </Typography>
          <Box 
            sx={{ 
              mt: 2, 
              p: 2, 
              backgroundColor: '#f9f9f9', 
              borderRadius: 1,
              maxHeight: '200px',
              overflowY: 'auto'
            }}
          >
            <Typography variant="body2" component="div">
              <div
                dangerouslySetInnerHTML={{
                  __html: saveReportDialog.messageContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>').replace(/\n/g, '<br />')
                }}
              />
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setSaveReportDialog({ open: false, messageContent: '', onConfirm: null })}
            color="secondary"
          >
            Cancel
          </Button>
          <Button 
            onClick={async () => {
              if (saveReportDialog.onConfirm) {
                const success = await saveReportDialog.onConfirm();
                if (success) {
                  setSaveReportDialog({ open: false, messageContent: '', onConfirm: null });
                }
              }
            }}
            variant="contained"
            sx={{ 
              backgroundColor: '#29C0BB', 
              '&:hover': { backgroundColor: '#1ca8a4' } 
            }}
          >
            Save as Report
          </Button>
        </DialogActions>
      </Dialog>

      {/* Refine with AI: generate requested while the refined transcript is unsaved */}
      <RefinePendingDialog
        open={refinePendingDialog.open}
        onCancel={closeRefinePendingDialog}
        onSaveAndRun={async () => {
          const run = refinePendingDialog.onSaveAndRun;
          closeRefinePendingDialog();
          if (run) await run();
        }}
        onRunOriginal={async () => {
          const run = refinePendingDialog.onRunOriginal;
          closeRefinePendingDialog();
          if (run) await run();
        }}
      />

      {/* Refine with AI: refined transcript saved over a consultation that already has a report */}
      <RefineRegenerateDialog
        open={refineRegenerateDialog.open}
        onKeep={closeRefineRegenerateDialog}
        onRegenerate={regenerateAfterRefine}
      />

      {/* Floating Highlight Button — appears above selected text in the right panel */}
      {highlightBtnPos && (
        <Portal>
          <Box
            data-highlight-btn="true"
            sx={{
              position: 'fixed',
              left: highlightBtnPos.x,
              top: highlightBtnPos.y - 44,
              transform: 'translateX(-50%)',
              zIndex: 9999,
              bgcolor: '#1C1C2E',
              borderRadius: '8px',
              px: 1.5,
              py: 0.75,
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -6,
                left: '50%',
                transform: 'translateX(-50%)',
                borderWidth: '6px 6px 0',
                borderStyle: 'solid',
                borderColor: '#1C1C2E transparent transparent',
              },
            }}
          >
            <Button
              size="small"
              onClick={() => {
                if (writeSourcesEnabled) checkSelectedReportSources();
                else handleTextHighlight();
                setHighlightBtnPos(null);
              }}
              startIcon={retrieving
                ? <CircularProgress size={12} color="inherit" />
                : <HighlightIcon sx={{ fontSize: 14 }} />
              }
              disabled={retrieving}
              sx={{
                color: '#FFFFFF',
                textTransform: 'none',
                fontSize: 12,
                fontWeight: 600,
                minWidth: 0,
                p: 0,
                '&:hover': { bgcolor: 'transparent', opacity: 0.8 },
              }}
            >
              {retrieving ? 'Finding Sources...' : 'Check Sources'}
            </Button>
          </Box>
        </Portal>
      )}

      </Grid></ScribeThemeProvider>
    )
    }


    const [isEditing, setIsEditing] = useState(false);
    const [editedPatient, setEditedPatient] = useState(patient || {});
    const [fieldSubmitted, setFieldSubmitted] = useState(false);
    const [isPrefillingClinical, setIsPrefillingClinical] = useState(false);

    // Prefill with AI: suggest Clinical Information from this client's reports and
    // transcripts (already decrypted into historyItems). Adds to the pickers and fills
    // empty text fields only — never overwrites what the clinician typed — and lands in
    // the edit form, so nothing is stored until Save Changes.
    const handlePrefillClinical = async () => {
      const stripHtml = (html) => String(html || '').replace(/<[^>]+>/g, ' ');
      const notes = [];
      (historyItems || []).forEach((item) => {
        if (item.type === 'Document' && item.originalData?.content) {
          notes.push(stripHtml(item.originalData.content));
        } else if (item.type === 'Consultation') {
          const c = item.originalData || {};
          if (c.notes) notes.push(stripHtml(c.notes));
          else if (c.transcription) notes.push(stripHtml(c.transcription));
        }
      });
      const usable = notes.map((n) => n.trim()).filter((n) => n.length > 20);
      if (usable.length === 0) {
        setAlert('No reports or consultation notes yet to prefill from.', 'warning');
        return;
      }
      setIsPrefillingClinical(true);
      try {
        const response = await authedFetch(`${process.env.REACT_APP_MAIN_BACKEND_URL}/scribe/clinical-prefill`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ notes: usable, diagnosis_options: DSM5_CONDITIONS, condition_options: PRE_EXISTING_CONDITIONS }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'Could not prefill right now');

        const mergeList = (existing, suggested) => {
          const current = Array.isArray(existing) ? existing : [];
          return [...current, ...(suggested || []).filter((s) => !current.includes(s))];
        };
        const next = { ...editedPatient };
        let filled = 0;
        next.diagnosis = mergeList(editedPatient.diagnosis, data.diagnosis);
        if (next.diagnosis.length > (editedPatient.diagnosis || []).length) filled += 1;
        next.preExistingConditions = mergeList(editedPatient.preExistingConditions, data.pre_existing_conditions);
        if (next.preExistingConditions.length > (editedPatient.preExistingConditions || []).length) filled += 1;
        if (!(editedPatient.presenting_concerns || '').trim() && data.presenting_concerns) {
          next.presenting_concerns = data.presenting_concerns;
          filled += 1;
        }
        if (!(editedPatient.remarks || '').trim() && data.remarks) {
          next.remarks = data.remarks;
          filled += 1;
        }
        setEditedPatient(next);
        setAlert(
          filled ? 'Clinical information prefilled — review it, then Save Changes.' : 'Nothing new to add: the fields are already filled or the notes had no further detail.',
          filled ? 'success' : 'info',
        );
      } catch (error) {
        setAlert(error.message || 'Could not prefill right now', 'error');
      } finally {
        setIsPrefillingClinical(false);
      }
    };
    const [currentTab, setCurrentTabState] = useState('dashboard');
    const setCurrentTab = value => {
      if (value !== currentTab && confirmNavigation()) setCurrentTabState(value);
    };
    const hasSetInitialTab = useRef(false);
    const [isMindvaultLinked, setIsMindvaultLinked] = useState(null);
    const [isMindvaultLinkLoading, setIsMindvaultLinkLoading] = useState(true);
    const [mindvaultAccountLookup, setMindvaultAccountLookup] = useState(null);
    const mindvaultAccountKey = JSON.stringify([patient?.id, patient?.email, userDetails?.id]);
    const linkedContact = useLinkedClientContact({ patient, therapistUserId: userDetails?.id, connectionVersion: isMindvaultLinked, viewKey: currentTab });
    const displayedEditedPatient = linkedContact.readOnly ? {
      ...editedPatient,
      phone_code: linkedContact.patient?.phone_code || '',
      phoneNumber: linkedContact.patient?.phoneNumber || '',
      email: linkedContact.patient?.email || '',
    } : editedPatient;
    const [hiddenCaseOwnerIds, setHiddenCaseOwnerIds] = useState([]);
    const [linkedCaseOwnerNames, setLinkedCaseOwnerNames] = useState([]);

    useEffect(() => {
      let active = true;
      const checkMindvaultLink = async () => {
        if (!patient?.email || !userDetails?.id) {
          setIsMindvaultLinked(false);
          setIsMindvaultLinkLoading(false);
          return;
        }
        setIsMindvaultLinkLoading(true);
        try {
          // Connected = (booking OR access code) AND consent — server-side rule
          const { connected, hasMvAccount } = await getConnectionStatus(userDetails.id, patient.email, { throwOnError: true });
          if (!active) return;
          setIsMindvaultLinked(connected);
          setMindvaultAccountLookup({ key: mindvaultAccountKey, hasAccount: hasMvAccount });
        } catch (err) {
          console.error('Error checking mindvault link:', err);
          if (!active) return;
          setIsMindvaultLinked(false);
          setMindvaultAccountLookup(null);
        } finally {
          if (active) setIsMindvaultLinkLoading(false);
        }
      };

      checkMindvaultLink();
      return () => { active = false; };
    }, [patient?.email, userDetails?.id, mindvaultAccountKey]);

    const liveReportTools = useReportTools();

    // Share button in the report header. Reads the report from the Files list so it
    // shows (and flips) the same sharing state as the share icon in Files.
    const reportShare = report => {
      if (!report?.id) return undefined;
      const current = historyItems.find(item => String(item.id) === String(report.id)) || report;
      return {
        shared: isDocumentShared(current),
        linked: Boolean(isMindvaultLinked),
        loading: isMindvaultLinkLoading,
        onToggle: async () => {
          if (!isMindvaultLinked) return;
          const wasShared = isDocumentShared(current);
          if (await handleItemShare({ ...current, type: 'Document' })) {
            setAlert(wasShared ? 'Sharing stopped. The client can no longer see this report in MindVault.' : 'Shared with the client on MindVault. It also shows as shared in Files.', 'success');
          }
        },
      };
    };

    useEffect(() => {
      if (patient && Array.isArray(patient.case_owner)) {
        const hiddenIds = [];
        const normalizedOwners = patient.case_owner.reduce((acc, owner) => {
          if (owner && typeof owner === 'object' && owner.name) {
            acc.push(owner);
            return acc;
          }
          const ownerId = typeof owner === 'object' ? owner.id : owner;
          const member = teamMembersData.find((m) => m.id === ownerId);
          if (member) {
            acc.push(member);
          } else if (ownerId) {
            hiddenIds.push(ownerId);
          }
          return acc;
        }, []);

        setHiddenCaseOwnerIds(hiddenIds);
        setEditedPatient((prev) => ({
          ...prev,
          ...patient,
          phone_code: patient.phone_code || DEFAULT_PHONE_CODE,
          case_owner: normalizedOwners,
        }));
      }
    }, [patient, teamMembersData]);

    useEffect(() => {
      if (hasSetInitialTab.current) return;

      if (isMindvaultLinked === true) {
        setCurrentTab('dashboard');
        hasSetInitialTab.current = true;
      } else if (isMindvaultLinked === false) {
        setCurrentTab('profile');
        hasSetInitialTab.current = true;
      }
    }, [isMindvaultLinked]);

    useEffect(() => {
      if (!isMindvaultLinked) {
        setLinkedCaseOwnerNames([]);
        return;
      }
      const ownerIds = (patient.case_owner || [])
        .map((o) => (typeof o === 'object' ? o.id : o))
        .filter(Boolean);
      if (!ownerIds.length) {
        setLinkedCaseOwnerNames([]);
        return;
      }
      const fetchOwnerNames = async () => {
        const { data: usersData } = await supabase
          .from('user_accounts')
          .select('id, name')
          .in('id', ownerIds);
        if (!usersData?.length) return;
        const names = await Promise.all(
          usersData.map(async (u) => {
            const { data } = await supabase.rpc('decrypt_text', { encrypted_data: u.name });
            return data;
          })
        );
        setLinkedCaseOwnerNames(names.filter(Boolean));
      };
      fetchOwnerNames();
    }, [isMindvaultLinked, patient?.case_owner]);

    const renderDashboardContent = () => {
      return (
        <VitalsDashboard
          patient={patient}
          onLinkStatusChange={setIsMindvaultLinked}
          currentUserId={userDetails?.id}
        />
      );
    };

    const handleTabChange = (event, newValue) => {
      if (newValue === currentTab || !confirmNavigation()) return;
      setCurrentTab(newValue);
      if (newValue === 'consultations') {
        setWorkflowMode(null);
        setShowWorkflowSelector(true);
      }
    };
    const handleEdit = () => {
      setIsEditing(true);
    };

    // Resolve a case_owner entry (a team-member object OR a raw user-id string) to a team
    // member object. Returns null when the id can't be matched (e.g. team list not loaded
    // yet, or an owner outside the current team). This shields the UI from showing raw UUIDs
    // when case_owner hasn't been normalized into objects.
    const resolveCaseOwner = (owner) => {
      if (owner && typeof owner === 'object' && owner.name) return owner;
      const ownerId = owner && typeof owner === 'object' ? owner.id : owner;
      return (teamMembersData || []).find((m) => m.id === ownerId) || null;
    };

    // Display name for a case_owner entry; never returns a raw UUID (falls back to '').
    const getCaseOwnerName = (owner) => resolveCaseOwner(owner)?.name || '';

    const handleInputChange = (field) => (event) => {
      setEditedPatient({
        ...editedPatient,
        [field]: event.target.value
      });
    };

    const handleSave = async () => {
      if (linkedContact.loading || linkedContact.error || isMindvaultLinkLoading) {
        setAlert('Please wait for client contact verification, or retry it before saving. Your edits have not been saved.', 'error');
        return;
      }
      // Email is optional here for the same reason as on the create form: it is the
      // MindVault linking key, not an identity requirement. Clearing it only unlinks.
      if(!isMindvaultLinked && (!editedPatient.case_owner || editedPatient.case_owner.length === 0)) {
        setAlert('Please fill in all required fields.', 'error');
        return;
      }

      const { data: isUnique, error: rpcError } = await supabase.rpc('check_patient_email_unique_for_edit', {
        p_email: editedPatient.email,
        p_patient_id: id,
        p_team_id: currentOrg?.id ?? null,
      });
      if (rpcError) {
        console.error('Email uniqueness check failed:', rpcError);
        setAlert('Could not validate email. Please try again.', 'error');
        return;
      }
      if (!isUnique) {
        setAlert('A client with this email address already exists. Each client must have a unique email.', 'error');
        return;
      }

      const birthDate = editedPatient.birth_date ? new Date(editedPatient.birth_date) : null;
      let age = null;
      
      if (birthDate) {
        const today = new Date();
        age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
      }

      const fullName = `${editedPatient.lastName} ${editedPatient.firstName}`;
      
      // Extract IDs from case_owner objects (only used for non-linked accounts)
      const visibleOwnerIds = !isMindvaultLinked && Array.isArray(editedPatient.case_owner) && editedPatient.case_owner.length > 0
        ? editedPatient.case_owner.map((owner) => (typeof owner === 'object' ? owner.id : owner))
        : [];

      const combinedCaseOwnerIds = Array.from(
        new Set([...(hiddenCaseOwnerIds || []), ...visibleOwnerIds])
      );

      const { data, error } = await supabase
        .from('patients')
        .update({
          updatedAt: new Date(),
          name: fullName,
          firstName: editedPatient.firstName,
          lastName: editedPatient.lastName,
          gender: editedPatient.gender,
          birth_date: birthDate,
          age: age,
          preExistingConditions: editedPatient.preExistingConditions || [],
          ...(!isMindvaultLinked && { case_owner: combinedCaseOwnerIds }),
          remarks: editedPatient.remarks,
          status: editedPatient.status,
          hkid: editedPatient.hkid,
          ...(!linkedContact.readOnly && !isMindvaultLinked && {
            phoneNumber: editedPatient.phoneNumber,
            phone_code: editedPatient.phone_code || DEFAULT_PHONE_CODE,
            email: editedPatient.email || '',
          }),
          emergency_contact: editedPatient.emergency_contact || '',
          emergency_contact_person: editedPatient.emergency_contact_person || '',
          presenting_concerns: editedPatient.presenting_concerns || '',
          diagnosis: editedPatient.diagnosis || [],
        })
        .eq('id', id)
        .select();

      if (error) {
        console.error('Error updating patient:', error);
        setAlert('Error updating client', 'error');
        return;
      }

      const [
        nameResult,
        phoneCodeResult,
        phoneNumberResult,
        firstNameResult,
        lastNameResult,
        genderResult,
        ageResult,
        birthDateResult,
        hkidResult,
        remarksResult,
        statusResult,
        latestComplaintResult,
        insightsResult,
        emergencyContactResult,
        emergencyContactPersonResult,
        presentingConcernsResult,
        emailResult
      ] = await Promise.all([
        supabase.rpc('decrypt_text', { encrypted_data: data[0].name }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].phone_code }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].phoneNumber }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].firstName }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].lastName }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].gender }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].age }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].birth_date }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].hkid }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].remarks }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].status }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].latestComplaint }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].insights }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].emergency_contact }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].emergency_contact_person }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].presenting_concerns }),
        supabase.rpc('decrypt_text', { encrypted_data: data[0].email }),
      ]);

      if(nameResult.error || phoneCodeResult.error || phoneNumberResult.error || firstNameResult.error || lastNameResult.error || genderResult.error || ageResult.error || birthDateResult.error || hkidResult.error || remarksResult.error || statusResult.error || latestComplaintResult.error || insightsResult.error || emergencyContactResult.error || presentingConcernsResult.error || emergencyContactPersonResult.error || emailResult.error) {
        setAlert('Error decrypting client data', 'error');
        return;
      }

      // Convert case_owner IDs back to objects for the state
      const caseOwnerObjects = combinedCaseOwnerIds.map((ownerId) => {
        const member = teamMembersData.find((m) => m.id === ownerId);
        return member || null;
      }).filter(Boolean);

      setHiddenCaseOwnerIds(
        combinedCaseOwnerIds.filter((ownerId) => !teamMembersData.some((m) => m.id === ownerId))
      );

      const decryptedPatient = {
        ...data[0],
        name: nameResult.data,
        phone_code: phoneCodeResult.data,
        phoneNumber: phoneNumberResult.data,
        firstName: firstNameResult.data,
        lastName: lastNameResult.data,
        gender: genderResult.data,
        age: ageResult.data,
        birth_date: birthDateResult.data,
        hkid: hkidResult.data,
        remarks: remarksResult.data,
        status: statusResult.data,
        latestComplaint: latestComplaintResult.data,
        insights: insightsResult.data,
        case_owner: isMindvaultLinked
          ? (data[0].case_owner || patient.case_owner || [])
          : caseOwnerObjects,
        emergency_contact: emergencyContactResult.data,
        emergency_contact_person: emergencyContactPersonResult.data,
        presenting_concerns: presentingConcernsResult.data,
        email: emailResult.data,
      };

      applySavedPatient({
        patient: decryptedPatient,
        location,
        navigate,
        setPatient,
        setEditedPatient,
      });
      setIsEditing(false);
      setFieldSubmitted(false);
      setAlert('Client updated successfully', 'success');
    };


    const renderContactStatus = () => linkedContact.loading
      ? <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}><CircularProgress size={20} /><Typography>Loading client contact details…</Typography></Box>
      : linkedContact.error
        ? <Alert severity="error" sx={{ mb: 2 }} action={<Button onClick={linkedContact.refresh}>Retry</Button>}>{linkedContact.error}</Alert>
        : null;
    const renderProfileContent = () => (<>{renderContactStatus()}<PatientProfilePanel DEFAULT_PHONE_CODE={DEFAULT_PHONE_CODE} editedPatient={displayedEditedPatient} fieldSubmitted={fieldSubmitted} getCaseOwnerName={getCaseOwnerName} handleInputChange={handleInputChange} isEditing={isEditing} isMindvaultLinked={isMindvaultLinked} hasMindvaultAccount={mindvaultAccountLookup?.key === mindvaultAccountKey ? mindvaultAccountLookup.hasAccount : null} isMindvaultLinkLoading={isMindvaultLinkLoading} contactReadOnly={linkedContact.readOnly || isMindvaultLinked} isPrefillingClinical={isPrefillingClinical} linkedCaseOwnerNames={linkedCaseOwnerNames} onPrefillClinical={handlePrefillClinical} openDialog={openDialog} patient={patient} setAlert={setAlert} setEditedPatient={setEditedPatient} setOpenDialog={setOpenDialog} teamMembersData={teamMembersData} /><ClientConsentLog key={`${id}:${patient?.email || ''}:${userDetails?.id || ''}`} clientEmail={patient?.email} patientId={id} userId={userDetails?.id} /></>)

    return (
        <Container disableGutters maxWidth={false}>
          <GlobalStyles styles={`
              @keyframes pulse {
                0%, 100% {
                  transform: scale(0.75);
                  opacity: 0.5;
                }
                50% {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            `} />
          {/* Clip horizontal overflow without creating a scroll ancestor that traps Sophie's sticky column. */}
          <Grid container sx={{ overflowX: 'clip', minHeight: '100vh', width: '100%', minWidth: 0 }}>
            <Grid size={{xs: 1, md: 0.5}}>
              <MiniDrawer />
            </Grid>
            <Grid size="grow">
              <Grid container spacing={5} sx={{ backgroundColor: '#F8F9FA', display: 'flex', flexDirection: 'column',  width: '100%', height: '100%' }}>
                <Grid size={12}>
                <div style={{ paddingTop: 24, paddingBottom: 24 }}>
                  <Grid container spacing={2} sx={{ padding: '0px 50px' }}>
                      <Grid size={12} sx={{ marginBottom: '16px', display: 'flex', flexDirection: "column", alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                          {/* Breadcrumb */}
                          <Typography variant="body2" sx={{ color: '#6B7280', mb: 2 }}>
                            <Box
                              component="span"
                              onClick={() => {navigate('/consultation')}}
                              sx={{
                                cursor: 'pointer',
                                color: '#29C0BB',
                                fontWeight: 600,
                                '&:hover': { textDecoration: 'underline' }
                              }}
                            >
                              Client List
                            </Box>
                            <span style={{margin: '0 8px'}}>/</span>
                            <span style={{color: "#374151"}}>
                              {isMindvaultLinkLoading
                                ? <Skeleton variant="text" width={100} sx={{ display: 'inline-block' }} />
                                : `${patient.firstName ?? ''} ${patient.lastName ?? ''}`.trim()}
                            </span>
                          </Typography>

                          {/* Compact Patient Summary Header */}
                          <PatientSummaryHeader editedPatient={displayedEditedPatient} getCaseOwnerName={getCaseOwnerName} isEditing={isEditing} isMindvaultLinkLoading={isMindvaultLinkLoading} isMindvaultLinked={isMindvaultLinked} linkedCaseOwnerNames={linkedCaseOwnerNames} patient={linkedContact.patient || patient} setCurrentTab={setCurrentTab} />

                          {
                            !isMindvaultLinkLoading ? (
                              <Grid container spacing={2} sx={{ width: '100%' }}>
                                <Grid size={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                  <PatientWorkspaceNavigation value={currentTab} onChange={handleTabChange}
                                    sophieOpen={isChatOpen} onToggleSophie={() => {
                                      setIsChatOpen(!isChatOpen); setIsAnswerSourceOpen(chatMessages.length !== 0);
                                    }}>
                                  {currentTab === 'profile' && (
                                    <Box sx={{ display: 'flex', gap: 1.5, flexShrink: 0 }}>
                                      {isEditing ? (
                                        <>
                                          <Button
                                            variant="contained"
                                            startIcon={<SaveIcon />}
                                            disabled={linkedContact.loading || Boolean(linkedContact.error) || isMindvaultLinkLoading}
                                            onClick={() => { setFieldSubmitted(true); handleSave(); }}
                                            sx={{
                                              backgroundColor: '#29C0BB',
                                              '&:hover': { backgroundColor: '#1ca8a4' },
                                              borderRadius: '8px',
                                              textTransform: 'none',
                                              fontWeight: 600,
                                              px: 2.5,
                                              boxShadow: 'none',
                                            }}
                                          >
                                            Save Changes
                                          </Button>
                                          <Button
                                            variant="outlined"
                                            onClick={() => { setIsEditing(false); setEditedPatient({ ...patient, case_owner: (patient.case_owner || []).map(resolveCaseOwner).filter(Boolean) }); }}
                                            sx={{
                                              borderColor: '#D1D5DB',
                                              color: '#374151',
                                              borderRadius: '8px',
                                              textTransform: 'none',
                                              fontWeight: 500,
                                              '&:hover': { borderColor: '#9CA3AF' },
                                            }}
                                          >
                                            Cancel
                                          </Button>
                                        </>
                                      ) : (
                                        <>
                                          <Button
                                            variant="contained"
                                            startIcon={<EditIcon />}
                                            onClick={handleEdit}
                                            sx={{
                                              backgroundColor: '#29C0BB',
                                              '&:hover': { backgroundColor: '#1ca8a4' },
                                              borderRadius: '8px',
                                              textTransform: 'none',
                                              fontWeight: 600,
                                              px: 2.5,
                                              boxShadow: 'none',
                                            }}
                                          >
                                            Edit Profile
                                          </Button>
                                          <Button
                                            variant="outlined"
                                            startIcon={<DeleteIcon />}
                                            onClick={() => { setOpenDialog({open: true, content: "Are you sure you want to delete this client?", confirmAction: () => deletePatient()}) }}
                                            sx={{
                                              borderColor: '#FCA5A5',
                                              color: '#DC2626',
                                              borderRadius: '8px',
                                              textTransform: 'none',
                                              fontWeight: 500,
                                              '&:hover': { borderColor: '#EF4444', backgroundColor: '#FEF2F2' },
                                            }}
                                          >
                                            Delete
                                          </Button>
                                        </>
                                      )}
                                    </Box>
                                  )}
                                  </PatientWorkspaceNavigation>
                                </Grid>
                                <Grid size={12}>
                                  <SophieWorkspaceLayout open={isChatOpen} assistant={<ScribeThemeProvider><SophieAssistantPanel
                                    onClose={() => setIsChatOpen(false)} chatBoxRef={chatBoxRef} onScroll={handleChatScroll}
                                    messages={renderChatMessageList()} contextLabel={sophieContextLabel}
                                    newMessage={newMessage} setNewMessage={setNewMessage} onSend={sendSophieMessage} /></ScribeThemeProvider>}>
                                  {layout => <>
                                  {/* {userMode === 'Corporates' && currentTab === 'dashboard' && renderDashboardContent()} */}
                                  {currentTab === 'dashboard' && renderDashboardContent()}
                                  {currentTab === 'profile' && renderProfileContent()}
                                  {currentTab === 'packages' && (linkedContact.loading || linkedContact.error
                                    ? renderContactStatus() : <ClientPackages key={id} client={linkedContact.patient} />)}
                                  {currentTab === 'consultations' && renderConsultationTab(layout)}
                                  {currentTab === 'files' && consultationLoading && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, py: 8 }}>
                                      <CircularProgress size={40} sx={{ color: '#29C0BB' }} />
                                      <Typography variant="body2" sx={{ color: '#6B7280' }}>Loading files&hellip;</Typography>
                                    </Box>
                                  )}
                                  {currentTab === 'files' && !consultationLoading && (
                                    <PatientDocuments
                                      patientId={id}
                                      historyItems={historyItems}
                                      currentUserId={userDetails?.id}
                                      isAdminUser={isAdminUser}
                                      handleViewItem={handleViewItem}
                                      handleDeleteItem={handleDeleteItem}
                                      handleDownloadReport={handleDownloadReport}
                                      handlePatientFileUpload={handlePatientFileUpload}
                                      convertToGMT8Date={convertToGMT8Date}
                                      setAlert={setAlert}
                                      setOpenDialog={setOpenDialog}
                                      openDialog={openDialog}
                                      isUploading={isUploading}
                                      onPreviewItem={(item) => { setPreviewItem(item); setPreviewOpen(true); }}
                                      selectedItems={selectedItems}
                                      toggleItemSelection={toggleItemSelection}
                                      clearAllSelections={clearAllSelections}
                                      deleteSelectedHistoryItems={deleteSelectedHistoryItems}
                                      isMindvaultLinked={!!isMindvaultLinked}
                                      isMindvaultLinkLoading={isMindvaultLinkLoading}
                                      handleItemShare={(item) => {
                                        // Sharing only means something once the client is
                                        // connected (paid link + consent); otherwise MindVault
                                        // never surfaces the item, so don't flip the flag.
                                        if (!isMindvaultLinked) {
                                          setAlert('Connect with this client on MindVault before sharing files.', 'warning');
                                          return;
                                        }
                                        handleItemShare(item);
                                      }}
                                    />
                                  )}
                                  </>}
                                  </SophieWorkspaceLayout>
                                </Grid>
                              </Grid>
                            )
                            :
                            (<Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                width: '100%', 
                                height: '50vh' 
                              }}>
                              <CircularProgress size={60} sx={{ color: '#29C0BB' }} />
                            </Box>)
                          }
                      </Grid>
                  </Grid>
                </div>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        <UploadIndicator isUploading={isUploading} progress={fileUploadProgress} />
        <DownloadIndicator isDownloading={isDownloading} />
        <DocumentPreviewModal
          onOcr={ATTACHMENT_OCR_ENABLED ? openGeneralOcr : undefined}
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          item={previewItem}
          onOpenSideBySide={(item) => { if (writeSourcesEnabled && item.type === 'Document') { showWriteDocument(item); setPreviewOpen(false); return; } if (!confirmNavigation()) return; handleViewItem(item); setPreviewOpen(false); setCurrentTab('consultations'); if (!workflowMode) setWorkflowMode('live-consultation'); }}
          onDownload={(item) => item.type === 'Document' ? handleDownloadReport(item) : downloadAttachment(item)}
          onDelete={(item) => { handleDeleteItem(item); setPreviewOpen(false); }}
          onEditTitle={(item) => { handleStartEditTitle(item); setPreviewOpen(false); }}
          onTranscribe={(item) => { handleTranscribeAudio(item); setPreviewOpen(false); }}
          retrieveAttachmentFile={retrieveAttachmentFile}
        />
        {ATTACHMENT_OCR_ENABLED && ocrItem && !writeSourcesEnabled && !ocrOpenedInWrite.current && <AttachmentOcrDialog key={ocrItem.path}
          item={ocrItem} autoRun={ocrAutoRun} queue={ocrQueue}
          onSelectFile={path => { setOcrItem(ocrQueue.find(item => item.path === path)); setOcrRefresh(value => value + 1); }}
          onClose={() => { setOcrItem(null); setOcrQueue([]); setOcrAutoRun(false); setOcrRefresh(value => value + 1); }} retrieveAttachmentFile={retrieveAttachmentFile} />}
        {sharingDialog}
      </Container>
    );};

function ConsultationSummaryRoute() {
  return <ClientWorkspaceRoute><ConsultationSummary /></ClientWorkspaceRoute>;
}

export default ConsultationSummaryRoute;
